// Vanuatu National Curriculum - Primary Years 4-6
// Based on Official Vanuatu National Syllabus 2013 (Years 4-6)
// Updated with official outcome codes and descriptions from Ministry of Education

// Year 4-6 Yearly Outcomes based on Official Vanuatu National Primary Syllabus
export const years4to6Outcomes = {
  languageCommunication: {
    "listening-speaking": {
      "Year 4": [
        "LSSS.4.1: Demonstrate listening and speaking skills and strategies to communicate for familiar purposes and situations",
        "LSP.4.1: Listen, understand, speak and interact for a range of familiar purposes and situations",
        "LSCT.4.1: Demonstrate how spoken language changes to suit a range of familiar purposes and situations"
      ],
      "Year 5": [
        "LSSS.5.1: Use listening and speaking skills and strategies to communicate for a variety of purposes and audiences",
        "LSP.5.1: Listen, speak and interact in formal and informal situations for a variety of purposes and audiences",
        "LSCT.5.1: Compare how spoken language changes to suit a range of purposes and audiences"
      ],
      "Year 6": [
        "LSSS.6.1: Apply listening and speaking skills and strategies to communicate effectively for different purposes, situations and audiences",
        "LSP.6.1: Listen and communicate clearly for a range of purposes, situations and audiences",
        "LSCT.6.1: Adapt spoken language to suit different purposes, situations and audiences"
      ]
    },
    "reading": {
      "Year 4": [
        "RSS.4.1: Demonstrate a range of skills and strategies to read and understand familiar English texts",
        "RP.4.1: Read and understand a range of familiar texts in English",
        "RCT.4.1: Identify familiar text types used for different purposes"
      ],
      "Year 5": [
        "RSS.5.1: Apply a wide range of skills and strategies to read and understand fiction and non-fiction texts",
        "RP.5.1: Read with understanding a range of fiction and non-fiction texts",
        "RCT.5.1: Discuss how different text types are used for different purposes and situations"
      ],
      "Year 6": [
        "RSS.6.1: Select and apply suitable skills and strategies to read and understand fiction and non-fiction texts",
        "RP.6.1: Read with understanding a wide range of more complex fiction and non-fiction texts",
        "RCT.6.1: Analyse how language changes in different text types to suit the purpose and audience"
      ]
    },
    "writing": {
      "Year 4": [
        "WSS.4.1: Identify and use punctuation, grammar, language rules and the writing process",
        "WSS.4.2: Apply handwriting techniques to write fluently and legibly",
        "WP.4.1: Write sentences and paragraphs to create a range of simple texts",
        "WCT.4.1: Discuss how own texts differ according to their purpose and audience"
      ],
      "Year 5": [
        "WSS.5.1: Demonstrate language knowledge, skills, strategies and the writing process",
        "WP.5.1: Write a range of fiction and non-fiction texts",
        "WCT.5.1: Explain how written language changes to suit the purpose and audience"
      ],
      "Year 6": [
        "WSS.6.1: Apply language knowledge, skills, strategies and the writing process effectively",
        "WP.6.1: Create a range of more complex fiction and non-fiction texts",
        "WCT.6.1: Adapt written language for a variety of purposes and audiences"
      ]
    },
    "viewing": {
      "Year 4": [
        "VSS.4.1: Identify key features and techniques in simple visual texts",
        "VP.4.1: View, interpret and create simple visual texts",
        "VCT.4.1: Discuss the purposes and audiences for simple visual texts"
      ],
      "Year 5": [
        "VSS.5.1: Demonstrate how different features and techniques are used to communicate meaning in visual texts",
        "VP.5.1: View, interpret and create a range of visual texts",
        "VCT.5.1: Discuss and compare how a range of visual texts is used for different purposes and audiences"
      ],
      "Year 6": [
        "VSS.6.1: Adapt and use features and techniques to interpret and create meaning in a range of visual texts",
        "VP.6.1: Analyse, interpret and create a range of visual texts",
        "VCT.6.1: Select and use appropriate visual texts for different purposes and audiences"
      ]
    }
  },
  mathematics: {
    "number": {
      "Year 4": [
        "NWN.4.1: Read, represent, compare and order whole numbers up to 10 000",
        "NO.4.1: Solve word and number problems using addition and subtraction up to 4-digit numbers",
        "NO.4.2: Solve word and number problems involving multiplication of 2- and 3-digit numbers by 1-digit numbers",
        "NO.4.3: Solve word and number problems involving division of up to 3-digit numbers by 1-digit numbers",
        "NO.4.4: Solve simple mental calculations",
        "NFD.4.1: Demonstrate understanding of simple fractions and ratios"
      ],
      "Year 5": [
        "NWN.5.1: Read, represent, compare and order whole numbers up to 100 000",
        "NO.5.1: Solve word and number problems using addition and subtraction up to 5-digit numbers",
        "NO.5.2: Solve word and number problems involving multiplication of 2- and 3-digit numbers by 1- and 2-digit numbers",
        "NO.5.3: Solve word and number problems involving division of up to 4-digit numbers by 1- or 2-digit numbers",
        "NO.5.4: Solve more complex mental calculations",
        "NFD.5.1: Solve problems related to fractions, decimals and ratios"
      ],
      "Year 6": [
        "NWN.6.1: Read, represent, compare and order whole numbers up to at least 1 000 000",
        "NO.6.1: Solve word and number problems using addition and subtraction up to 6-digit numbers",
        "NO.6.2: Solve word and number problems involving multiplication of 4- and 5-digit numbers by up to 3-digit numbers",
        "NO.6.3: Solve word and number problems involving division of up to 5-digit numbers by 1- or 2-digit numbers",
        "NO.6.4: Solve mental calculations by applying a range of strategies",
        "NFD.6.1: Solve problems related to fractions, decimals, ratios and percentage"
      ]
    },
    "measurement": {
      "Year 4": [
        "ML.4.1: Estimate, measure, compare and solve simple problems relating to length and perimeter, using standard units",
        "MA.4.1: Estimate, measure and compare the area of squares and rectangles using non-standard and standard units",
        "MM.4.1: Estimate, measure, compare and solve simple problems relating to the mass of objects, using standard units",
        "MMCV.4.1: Estimate, measure, compare and solve simple problems relating to capacity and volume using standard units",
        "MMO.4.1: Estimate and solve real life problems involving changing money and giving change"
      ],
      "Year 5": [
        "ML.5.1: Estimate, measure, compare and solve problems relating to length and perimeter, using appropriate standard units",
        "MA.5.1: Estimate, measure, compare and solve problems relating to the area of squares, rectangles and triangles using appropriate standard units",
        "MM.5.1: Estimate, measure, compare and solve problems relating to the mass of objects, using appropriate standard units",
        "MMCV.5.1: Estimate, measure, compare and solve problems relating to the capacity and volume of objects, using appropriate standard units",
        "MT.5.1: Interpret calendars, convert units of time, estimate and read the time in 1-minute intervals",
        "MMO.5.1: Estimate and solve problems involving everyday calculations relating to purchasing and sales"
      ],
      "Year 6": [
        "ML.6.1: Apply estimation and measurement skills to practical problems involving length and perimeter",
        "MA.6.1: Apply estimation and measurement skills to practical problems involving area of quadrilaterals, triangles and complex shapes",
        "MM.6.1: Apply estimation and measurement skills to practical problems involving mass",
        "MMCV.6.1: Apply estimation and measurement skills to practical problems involving capacity and volume",
        "MT.6.1: Estimate and read time accurately in a range of ways and solve real life problems relating to time",
        "MMO.6.1: Estimate and solve real life problems relating to percentage of sums of money and banking"
      ]
    },
    "geometry": {
      "Year 4": [
        "GPSS.4.1: Recognise, represent, compare and describe lines, angles, plane shapes and solids",
        "GO.4.1: Use simple maps and grids to represent position and follow directions"
      ],
      "Year 5": [
        "GPSS.5.1: Represent, compare and classify lines, angles, plane shapes and solids",
        "GO.5.1: Create, interpret and follow directions using simple maps"
      ],
      "Year 6": [
        "GPSS.6.1: Represent, classify and describe lines, angles, plane shapes and solids",
        "GO.6.1: Use a variety of mapping skills to create and interpret maps"
      ]
    },
    "patterns": {
      "Year 4": [
        "PP.4.1: Create, describe, represent and extend whole number and simple geometric patterns"
      ],
      "Year 5": [
        "PP.5.1: Create, represent, explain and extend number and geometric patterns"
      ],
      "Year 6": [
        "PP.6.1: Create, represent, analyse and extend complex number and geometric patterns"
      ]
    },
    "chance-data": {
      "Year 4": [
        "CDP.4.1: Predict, compare and sort the likelihood of events occurring in everyday life and in simple games",
        "CDD.4.1: Collect, organise, represent and interpret simple data"
      ],
      "Year 5": [
        "CDP.5.1: Predict, compare, order and explain the likely results of events and games involving chance",
        "CDD.5.1: Collect, organise, represent and interpret data using tables and graphs"
      ],
      "Year 6": [
        "CDP.6.1: Predict, record, compare and order the likely outcomes of events and games and represent as fractions or percentage",
        "CDD.6.1: Organise and represent data in a variety of ways and interpret the results"
      ]
    }
  },
  science: {
    "living-things": {
      "Year 4": [
        "LE.LT.4.1: Recognise different habitats support different organisms",
        "LE.SL.4.1: Identify and describe the external body parts of animals and plants that help them to survive",
        "LE.SL.4.2: Identify human internal body parts that support and protect the body and help it move",
        "LE.BRS.4.1: Investigate the environment and recognise living things, populations and communities that live locally"
      ],
      "Year 5": [
        "LE.LT.5.1: Identify and describe plants and animals that live together in a local habitat",
        "LE.SL.5.1: Identify and describe the internal body parts of animals that support the digestive system",
        "LE.SL.5.2: Identify internal human body parts that help with digestion",
        "LE.BRS.5.1: Investigate and explain the effect on living things when the environment becomes unfavourable"
      ],
      "Year 6": [
        "LE.LT.6.1: Investigate and describe the energy pathway from the Sun to plants and animals",
        "LE.SL.6.1: Describe ways in which nutrients, water and oxygen are transported within plants",
        "LE.SL.6.2: Identify internal human body parts that help with breathing and circulation",
        "LE.BRS.6.1: Describe how physical features and other adaptations of living things help them to survive in their environment"
      ]
    },
    "matter": {
      "Year 4": [
        "IM.M.4.1: Recognise the physical world is made up of natural and synthetic materials with a variety of properties",
        "IM.FC.4.1: Recognise that water can exist in three interchangeable states of matter",
        "IM.R.4.1: Identify changes in the appearance and properties of common materials used locally"
      ],
      "Year 5": [
        "IM.M.5.1: Investigate the physical properties of natural and synthetic materials and demonstrate how these properties determine their uses",
        "IM.FC.5.1: Investigate and identify simple properties of solids, liquids and gases",
        "IM.R.5.1: Demonstrate and describe ways common materials can be changed temporarily or permanently to form materials with different properties"
      ],
      "Year 6": [
        "IM.M.6.1: Investigate, observe and record the changes that occur when combining materials",
        "IM.FC.6.1: Represent and explain the water cycle and show concern that water is a limited natural resource",
        "IM.R.6.1: Predict and conduct experiments to describe ways of producing permanent or temporary changes in some familiar materials"
      ]
    },
    "energy": {
      "Year 4": [
        "EE.ET.4.1: Recognise that energy is required to make things work or move and that the Sun is our primary source of light and heat energy",
        "EE.ETC.4.1: Investigate and identify common sources, transfer and transformation of energy",
        "EE.F.4.1: Investigate and identify forces as a push or a pull"
      ],
      "Year 5": [
        "EE.ET.5.1: Recognise and give examples of various forms of energy",
        "EE.ETC.5.1: Investigate and explain ways energy is transformed in everyday life from one form to another",
        "EE.F.5.1: Demonstrate the effects of a force"
      ],
      "Year 6": [
        "EE.ET.6.1: Identify some common sources of heat and investigate materials which conduct heat",
        "EE.ETC.6.1: Describe ways to conserve energy use in our everyday lives and explain why it is important",
        "EE.F.6.1: Recognise, demonstrate and give examples of different types of forces in everyday life"
      ]
    },
    "earth-space": {
      "Year 4": [
        "OES.OSS.4.1: Investigate and recognise that our solar system is made up of the Sun, the Earth and other planets",
        "OES.OCE.4.1: Investigate and describe features that occur naturally and those that are the result of human activities"
      ],
      "Year 5": [
        "OES.OSS.5.1: Investigate and explain the impacts of the Earth's rotation on its own axis once every day",
        "OES.OCE.5.1: Identify and explain causes and visible effects of natural processes and describe ways humans can minimise their impact and adapt to changes"
      ],
      "Year 6": [
        "OES.OSS.6.1: Investigate and explain the impacts of the tilt of the Earth's axis and the orbiting of the Sun once every year",
        "OES.OCE.6.1: Identify and explain causes and visible effects of human activities and describe ways humans can minimise their impact and adapt to changes"
      ]
    },
    "agriculture": {
      "Year 4": [
        "A.SE.4.1: Identify the basic characteristics of a good garden soil and simple ways to increase soil fertility",
        "A.GC.4.1: Identify and apply basic skills to plant, feed, weed and harvest crops"
      ],
      "Year 5": [
        "A.SE.5.1: Demonstrate basic skills to prepare garden soil ready for planting crops",
        "A.GC.5.1: Identify the main tasks needed to grow and take care of common vegetables"
      ],
      "Year 6": [
        "A.SE.6.1: Apply basic skills and knowledge to make compost and control pests",
        "A.GC.6.1: Identify the main tasks needed to grow and take care of common garden fruits",
        "A.FA.6.1: Describe simple techniques to raise common farm animals"
      ]
    }
  },
  socialScience: {
    "culture-heritage": {
      "Year 4": [
        "CHCV.4.1: Explore and identify the purposes of different cultural groups and the related values and beliefs",
        "CHSI.4.1: Identify and describe the islands of Vanuatu and their physical features",
        "CHSI.4.2: Understand and describe the early migration and history of Vanuatu",
        "CHSC.4.1: Identify common religious and moral values, practices, occasions and beliefs in the community",
        "CHCE.4.1: Identify and describe practices to conserve the natural and built resources within their local environment"
      ],
      "Year 5": [
        "CHCV.5.1: Demonstrate an understanding of different traditional beliefs, rituals, norms, practices and ways of communicating",
        "CHSI.5.1: Describe and compare the provinces, main towns and villages of Vanuatu",
        "CHSI.5.2: Describe the period of time when Europeans arrived in New Hebrides",
        "CHSC.5.1: Compare religious and moral values, practices, occasions and beliefs in the community",
        "CHCE.5.1: Describe human activities and natural events that damage the local environment and investigate ways to reduce the damage"
      ],
      "Year 6": [
        "CHCV.6.1: Discuss and demonstrate the significant purposes of cultural ethics and practices, and how they are passed on and sustained",
        "CHSI.6.1: Describe and represent geographical features of Vanuatu and its place in the world",
        "CHSI.6.2: Investigate and describe the period of time during the Condominium and Independence",
        "CHSC.6.1: Explain how religious and moral values, practices, occasions and beliefs influence how people live in their community",
        "CHCE.6.1: Identify environmental issues in the community and design and implement actions to address these issues"
      ]
    },
    "community-citizenship": {
      "Year 4": [
        "CCLW.4.1: Investigate and describe how people in urban and rural communities meet their needs and wants",
        "CCPN.4.1: Investigate and compare how people live in different Melanesian countries",
        "CCCG.4.1: Understand the importance of rules and how decisions are made in the family, at school and in the community",
        "EEV.4.1: Investigate and use basic enterprise values, skills and processes to solve simple practical problems"
      ],
      "Year 5": [
        "CCLW.5.1: Investigate and discuss the importance of different jobs and services in urban and rural communities",
        "CCPN.5.1: Investigate and compare how people live in different Micronesian countries",
        "CCCG.5.1: Identify and discuss rules, rights, freedoms, responsibilities, duties and decision making in the community",
        "EEV.5.1: Investigate and apply enterprise values, skills and strategies to implement practical projects"
      ],
      "Year 6": [
        "CCLW.6.1: Investigate and discuss trading and the exchange of goods within Vanuatu",
        "CCPN.6.1: Investigate and compare how people live in different Polynesian countries and in close trading countries",
        "CCCG.6.1: Investigate and identify how local systems of governance work",
        "EEV.6.1: Demonstrate enterprise values, skills and strategies to meet individual and community needs"
      ]
    }
  },
  artsAndCrafts: {
    "visual-arts": {
      "Year 4": [
        "VAC.4.1: Experiment with and use simple ideas, art skills, techniques and processes to create familiar visual art forms",
        "VAP.4.1: Present examples of artwork and describe the messages, ideas and feelings they are trying to convey"
      ],
      "Year 5": [
        "VAC.5.1: Investigate and apply arts skills, techniques and processes to create a range of visual art forms",
        "VAP.5.1: Present examples of artwork and explain the significance of the designs and techniques used to create them"
      ],
      "Year 6": [
        "VAC.6.1: Apply arts skills, techniques and processes to design and create a range of visual art forms that convey their own ideas and feelings",
        "VAP.6.1: Present examples of artwork and discuss how different techniques are used to convey different messages, ideas and feelings"
      ]
    },
    "performing-arts": {
      "Year 4": [
        "PAC.4.1: Experiment with and use knowledge, skills and techniques to create simple forms of music, dance and drama",
        "PAP.4.1: Perform simple forms of music, dance and drama and describe the messages, ideas and feelings they are trying to convey"
      ],
      "Year 5": [
        "PAC.5.1: Investigate and apply knowledge, skills and techniques to create a range of music, dance and drama",
        "PAP.5.1: Perform music, dance and drama and explain the significance of the music and movements and the techniques used to create them"
      ],
      "Year 6": [
        "PAC.6.1: Apply knowledge, skills and techniques to plan and create music, dance and drama that convey their own ideas and feelings",
        "PAP.6.1: Demonstrate skills and techniques in their own performances and discuss how messages, ideas and feelings are conveyed"
      ]
    },
    "crafts": {
      "Year 4": [
        "CC.4.1: Experiment with and use simple ideas, skills, techniques and processes to create familiar crafts",
        "CPE.4.1: Present examples of craftwork and describe their purpose and the significance of the designs"
      ],
      "Year 5": [
        "CC.5.1: Investigate and apply knowledge, skills, techniques and processes to create a range of crafts",
        "CPE.5.1: Present examples of craftwork and explain the significance of the designs and techniques used to create them"
      ],
      "Year 6": [
        "CC.6.1: Apply knowledge, skills, techniques and processes to design and create a range of crafts that are artistic and functional",
        "CPE.6.1: Present examples of craftwork and discuss their functions and how the techniques and designs are used to convey different messages, ideas and feelings"
      ]
    }
  },
  healthPE: {
    "personal-health": {
      "Year 4": [
        "HIC.PH.4.1: Identify and describe the food groups that promote good health",
        "HIC.PH.4.2: Describe and demonstrate personal hygiene practices to prevent illness",
        "HIC.GD.4.1: Recognise and describe simple ways to support healthy growth and development",
        "HIC.HC.4.1: Recognise and describe features of a healthy living environment"
      ],
      "Year 5": [
        "HIC.PH.5.1: Identify factors that influence eating habits and ways to overcome negative influences",
        "HIC.PH.5.2: Apply strategies to prevent common illness and disease",
        "HIC.GD.5.1: Identify the different stages of life and describe the changing health needs",
        "HIC.HC.5.1: Identify and describe the role of health services in the community"
      ],
      "Year 6": [
        "HIC.PH.6.1: Apply knowledge of good nutrition to demonstrate healthy food choices",
        "HIC.PH.6.2: Describe the causes of serious diseases and ways to prevent them",
        "HIC.GD.6.1: Identify changes that occur during puberty and ways to deal with the changes",
        "HIC.HC.6.1: Apply knowledge to promote healthy living in their communities"
      ]
    },
    "physical-education": {
      "Year 4": [
        "PE.MPA.4.1: Identify and demonstrate a range of locomotor and non-locomotor movements for coordination and fitness",
        "PE.MPA.4.2: Identify and demonstrate basic skills in a range of games"
      ],
      "Year 5": [
        "PE.MPA.5.1: Perform movement sequences in fitness and physical activities with coordination",
        "PE.MPA.5.2: Perform basic skills in a range of games and modified sports"
      ],
      "Year 6": [
        "PE.MPA.6.1: Apply movement, flexibility, strength and balance by participating in a range of fitness and physical activities",
        "PE.MPA.6.2: Apply skills and techniques by participating in a range of modified sports"
      ]
    },
    "safety": {
      "Year 4": [
        "S.SS.4.1: Identify drugs in their local community that affect their health",
        "S.SS.4.2: Identify dangerous situations at home and school and describe ways to minimise risks"
      ],
      "Year 5": [
        "S.SS.5.1: Investigate and describe the effects of drugs on personal health",
        "S.SS.5.2: Investigate and identify dangerous situations in the community and describe ways to minimise risks"
      ],
      "Year 6": [
        "S.SS.6.1: Demonstrate strategies to make healthy choices about drugs",
        "S.SS.6.2: Describe actions and basic first aid techniques to use in common emergency situations"
      ]
    }
  },
  // Backward-compatible alias for existing code that references livingInCommunity
  livingInCommunity: {
    "healthy-living": {
      "Year 4": [
        "HIC.PH.4.1: Identify and describe the food groups that promote good health",
        "HIC.PH.4.2: Describe and demonstrate personal hygiene practices to prevent illness",
        "HIC.GD.4.1: Recognise and describe simple ways to support healthy growth and development",
        "HIC.HC.4.1: Recognise and describe features of a healthy living environment"
      ],
      "Year 5": [
        "HIC.PH.5.1: Identify factors that influence eating habits and ways to overcome negative influences",
        "HIC.PH.5.2: Apply strategies to prevent common illness and disease",
        "HIC.GD.5.1: Identify the different stages of life and describe the changing health needs",
        "HIC.HC.5.1: Identify and describe the role of health services in the community"
      ],
      "Year 6": [
        "HIC.PH.6.1: Apply knowledge of good nutrition to demonstrate healthy food choices",
        "HIC.PH.6.2: Describe the causes of serious diseases and ways to prevent them",
        "HIC.GD.6.1: Identify changes that occur during puberty and ways to deal with the changes",
        "HIC.HC.6.1: Apply knowledge to promote healthy living in their communities"
      ]
    },
    "living-together": {
      "Year 4": [
        "CCLW.4.1: Investigate and describe how people in urban and rural communities meet their needs and wants",
        "CCPN.4.1: Investigate and compare how people live in different Melanesian countries",
        "CCCG.4.1: Understand the importance of rules and how decisions are made in the family, at school and in the community",
        "EEV.4.1: Investigate and use basic enterprise values, skills and processes to solve simple practical problems"
      ],
      "Year 5": [
        "CCLW.5.1: Investigate and discuss the importance of different jobs and services in urban and rural communities",
        "CCPN.5.1: Investigate and compare how people live in different Micronesian countries",
        "CCCG.5.1: Identify and discuss rules, rights, freedoms, responsibilities, duties and decision making in the community",
        "EEV.5.1: Investigate and apply enterprise values, skills and strategies to implement practical projects"
      ],
      "Year 6": [
        "CCLW.6.1: Investigate and discuss trading and the exchange of goods within Vanuatu",
        "CCPN.6.1: Investigate and compare how people live in different Polynesian countries and in close trading countries",
        "CCCG.6.1: Investigate and identify how local systems of governance work",
        "EEV.6.1: Demonstrate enterprise values, skills and strategies to meet individual and community needs"
      ]
    },
    "ways-of-living": {
      "Year 4": [
        "CHCV.4.1: Explore and identify the purposes of different cultural groups and the related values and beliefs",
        "VAC.4.1: Experiment with and use simple ideas, art skills, techniques and processes to create familiar visual art forms",
        "PAC.4.1: Experiment with and use knowledge, skills and techniques to create simple forms of music, dance and drama"
      ],
      "Year 5": [
        "CHCV.5.1: Demonstrate an understanding of different traditional beliefs, rituals, norms, practices and ways of communicating",
        "VAC.5.1: Investigate and apply arts skills, techniques and processes to create a range of visual art forms",
        "PAC.5.1: Investigate and apply knowledge, skills and techniques to create a range of music, dance and drama"
      ],
      "Year 6": [
        "CHCV.6.1: Discuss and demonstrate the significant purposes of cultural ethics and practices, and how they are passed on and sustained",
        "VAC.6.1: Apply arts skills, techniques and processes to design and create a range of visual art forms that convey their own ideas and feelings",
        "PAC.6.1: Apply knowledge, skills and techniques to plan and create music, dance and drama that convey their own ideas and feelings"
      ]
    }
  }
};

// Sample Activities for Years 4-6
export const sampleActivitiesYears4to6 = {
  "Year 4": {
    languageCommunication: [
      { activity: "Book Report Presentation", description: "Read a chapter book and present a summary to the class", strand: "Reading" },
      { activity: "Interview Project", description: "Interview a community elder and write a report in English", strand: "Listening and Speaking" },
      { activity: "Letter Writing", description: "Write a formal letter to a local organization", strand: "Writing" },
      { activity: "Graph Interpretation", description: "Analyse data from graphs and present findings", strand: "Viewing" }
    ],
    mathematics: [
      { activity: "Market Mathematics", description: "Calculate totals, change, and discounts at a pretend market", strand: "Number" },
      { activity: "Garden Measurement", description: "Measure and calculate perimeter of school garden beds", strand: "Measurement" },
      { activity: "Shape Hunt Challenge", description: "Photograph and classify shapes found in the community", strand: "Geometry" },
      { activity: "Pattern Investigation", description: "Find and document number patterns in nature", strand: "Patterns" }
    ],
    science: [
      { activity: "Animal Classification", description: "Sort local animals into vertebrate groups", strand: "Living Things" },
      { activity: "States of Matter Lab", description: "Experiment with ice, water, and steam transitions", strand: "Matter" },
      { activity: "Circuit Building", description: "Build simple circuits with batteries, wires, and bulbs", strand: "Energy" },
      { activity: "Weather Station", description: "Record daily weather data for a month", strand: "Earth and Space" }
    ],
    livingInCommunity: [
      { activity: "Nutrition Week", description: "Plan balanced meals using local foods", strand: "Healthy Living" },
      { activity: "Community Map", description: "Create a map showing local government services", strand: "Living Together" },
      { activity: "Cultural Festival", description: "Research and present a traditional custom", strand: "Ways of Living" }
    ]
  },
  "Year 5": {
    languageCommunication: [
      { activity: "Debate Club", description: "Participate in structured debates on local issues", strand: "Listening and Speaking" },
      { activity: "News Report Writing", description: "Write newspaper articles about school events", strand: "Writing" },
      { activity: "Novel Study", description: "Analyse characters, plot, and themes in a novel", strand: "Reading" },
      { activity: "Advertisement Analysis", description: "Critique visual techniques used in advertisements", strand: "Viewing" }
    ],
    mathematics: [
      { activity: "Fraction Cooking", description: "Use fractions while following recipes", strand: "Number" },
      { activity: "Area Architects", description: "Design floor plans and calculate areas", strand: "Measurement" },
      { activity: "Coordinate Treasure Hunt", description: "Use coordinates to find hidden items", strand: "Geometry" },
      { activity: "Data Survey Project", description: "Conduct surveys and create statistical displays", strand: "Chance and Data" }
    ],
    science: [
      { activity: "Body Systems Model", description: "Create models of human body systems", strand: "Living Things" },
      { activity: "Mixture Separation", description: "Separate mixtures using different methods", strand: "Matter" },
      { activity: "Energy Audit", description: "Audit energy use at home and school", strand: "Energy" },
      { activity: "Solar System Scale Model", description: "Create a scaled model of the solar system", strand: "Earth and Space" }
    ],
    livingInCommunity: [
      { activity: "Puberty Education", description: "Learn about physical and emotional changes", strand: "Healthy Living" },
      { activity: "Mock Parliament", description: "Simulate parliamentary debate and voting", strand: "Living Together" },
      { activity: "Cultural Exchange", description: "Share traditions with students from other islands", strand: "Ways of Living" }
    ]
  },
  "Year 6": {
    languageCommunication: [
      { activity: "Public Speaking Competition", description: "Deliver persuasive speeches on chosen topics", strand: "Listening and Speaking" },
      { activity: "Research Essay", description: "Write a research essay with citations", strand: "Writing" },
      { activity: "Literary Analysis", description: "Analyse themes and techniques in literature", strand: "Reading" },
      { activity: "Documentary Making", description: "Create a short documentary about local issues", strand: "Viewing" }
    ],
    mathematics: [
      { activity: "Business Simulation", description: "Run a small business calculating profit/loss with percentages", strand: "Number" },
      { activity: "Construction Project", description: "Calculate materials needed for building projects", strand: "Measurement" },
      { activity: "Transformation Art", description: "Create artwork using geometric transformations", strand: "Geometry" },
      { activity: "Statistical Investigation", description: "Design and conduct a complete statistical investigation", strand: "Chance and Data" }
    ],
    science: [
      { activity: "Genetics Investigation", description: "Explore inheritance patterns using family traits", strand: "Living Things" },
      { activity: "Chemistry Experiments", description: "Investigate acids and bases using indicators", strand: "Matter" },
      { activity: "Simple Machine Design", description: "Design and build simple machines to solve problems", strand: "Energy" },
      { activity: "Climate Action Plan", description: "Research climate change and propose local solutions", strand: "Earth and Space" }
    ],
    livingInCommunity: [
      { activity: "Health Campaign", description: "Design and implement a health awareness campaign", strand: "Healthy Living" },
      { activity: "Leadership Project", description: "Lead a school or community improvement project", strand: "Living Together" },
      { activity: "Cultural Portfolio", description: "Create a comprehensive portfolio of cultural knowledge", strand: "Ways of Living" }
    ]
  }
};

// Assessment Samples for Years 4-6
export const assessmentSamplesYears4to6 = {
  "Year 4": {
    languageCommunication: [
      {
        id: "y4-lang-1",
        title: "Reading Comprehension - Fiction",
        type: "quiz",
        questions: [
          { question: "What is the setting of the story?", options: ["Beach", "Mountain", "Village"], answer: "Village" },
          { question: "Who is the main character?", options: ["Tomas", "Maria", "John"], answer: "Tomas" },
          { question: "What problem did the character face?", options: ["Lost item", "New school", "Weather"], answer: "Lost item" },
          { question: "How was the problem solved?", options: ["By friends", "By luck", "By hard work"], answer: "By friends" },
          { question: "What is the theme of the story?", options: ["Friendship", "Adventure", "Learning"], answer: "Friendship" }
        ]
      },
      {
        id: "y4-lang-2",
        title: "Grammar and Vocabulary",
        type: "quiz",
        questions: [
          { question: "Choose the correct verb: She ___ to school every day.", options: ["go", "goes", "going"], answer: "goes" },
          { question: "The opposite of 'happy' is:", options: ["sad", "angry", "tired"], answer: "sad" },
          { question: "A word that means 'very big' is:", options: ["tiny", "huge", "small"], answer: "huge" },
          { question: "Choose the correct sentence:", options: ["He don't like fish", "He doesn't like fish", "He not like fish"], answer: "He doesn't like fish" }
        ]
      }
    ],
    mathematics: [
      {
        id: "y4-math-1",
        title: "Four Operations",
        type: "quiz",
        questions: [
          { question: "2,345 + 1,234 = ?", options: ["3,479", "3,579", "3,679"], answer: "3,579" },
          { question: "5,000 - 2,346 = ?", options: ["2,654", "2,754", "2,554"], answer: "2,654" },
          { question: "24 × 5 = ?", options: ["100", "120", "130"], answer: "120" },
          { question: "144 ÷ 12 = ?", options: ["11", "12", "13"], answer: "12" },
          { question: "What is 1/2 + 1/4?", options: ["2/4", "3/4", "1/4"], answer: "3/4" }
        ]
      }
    ]
  },
  "Year 5": {
    languageCommunication: [
      {
        id: "y5-lang-1",
        title: "Reading Analysis",
        type: "quiz",
        questions: [
          { question: "What technique does the author use to create suspense?", options: ["Short sentences", "Long descriptions", "Dialogue"], answer: "Short sentences" },
          { question: "What can you infer about the character's feelings?", options: ["Happy", "Worried", "Excited"], answer: "Worried" },
          { question: "What is the author's purpose?", options: ["To inform", "To persuade", "To entertain"], answer: "To entertain" },
          { question: "Compare the two characters - how are they different?", options: ["Age", "Personality", "Both"], answer: "Both" }
        ]
      }
    ],
    mathematics: [
      {
        id: "y5-math-1",
        title: "Fractions and Decimals",
        type: "quiz",
        questions: [
          { question: "3/4 + 1/4 = ?", options: ["1", "4/8", "1/2"], answer: "1" },
          { question: "2/3 - 1/3 = ?", options: ["1/3", "1/6", "2/6"], answer: "1/3" },
          { question: "Convert 0.5 to a fraction:", options: ["1/2", "1/5", "5/10"], answer: "1/2" },
          { question: "What is the mean of 4, 6, 8, 10?", options: ["6", "7", "8"], answer: "7" },
          { question: "What is 25% of 80?", options: ["15", "20", "25"], answer: "20" }
        ]
      }
    ]
  },
  "Year 6": {
    languageCommunication: [
      {
        id: "y6-lang-1",
        title: "Critical Reading",
        type: "quiz",
        questions: [
          { question: "What bias does the author show?", options: ["Positive", "Negative", "Neutral"], answer: "Positive" },
          { question: "Which evidence best supports the argument?", options: ["Opinion", "Statistic", "Anecdote"], answer: "Statistic" },
          { question: "What is the author's tone?", options: ["Formal", "Informal", "Humorous"], answer: "Formal" },
          { question: "How reliable is this source?", options: ["Very reliable", "Somewhat reliable", "Not reliable"], answer: "Somewhat reliable" }
        ]
      }
    ],
    mathematics: [
      {
        id: "y6-math-1",
        title: "Advanced Problem Solving",
        type: "quiz",
        questions: [
          { question: "If x + 5 = 12, what is x?", options: ["5", "7", "17"], answer: "7" },
          { question: "Calculate: 15% of 200", options: ["25", "30", "35"], answer: "30" },
          { question: "What is the area of a triangle with base 10cm and height 6cm?", options: ["30 cm²", "60 cm²", "16 cm²"], answer: "30 cm²" },
          { question: "Probability of rolling a 6 on a dice:", options: ["1/3", "1/6", "1/2"], answer: "1/6" },
          { question: "Solve: 3 × (4 + 2) = ?", options: ["14", "18", "10"], answer: "18" }
        ]
      }
    ],
    science: [
      {
        id: "y6-sci-1",
        title: "Scientific Inquiry",
        type: "quiz",
        questions: [
          { question: "What is the independent variable?", options: ["What you measure", "What you change", "What you keep same"], answer: "What you change" },
          { question: "Which is a good hypothesis?", options: ["Plants need water", "If plants get more light, they will grow taller", "Plants are green"], answer: "If plants get more light, they will grow taller" },
          { question: "What is cellular respiration?", options: ["Breathing", "Energy production in cells", "Cell division"], answer: "Energy production in cells" },
          { question: "What causes climate change?", options: ["Volcanoes only", "Greenhouse gases", "Earthquakes"], answer: "Greenhouse gases" }
        ]
      }
    ]
  }
};

// Yearly Planner Templates for Years 4-6
export const yearlyPlannerTemplatesYears4to6 = {
  "Year 4": {
    term1: {
      weeks: "1-10",
      themes: ["Building English Skills", "Numbers in Our World", "Living Systems"],
      subjects: {
        languageCommunication: ["Paragraph writing", "Reading fluency", "Oral presentations", "Chart reading"],
        mathematics: ["Numbers to 9,999", "Addition/subtraction strategies", "Introduction to angles", "Pattern rules"],
        science: ["Animal classification", "Life cycles", "States of matter"],
        livingInCommunity: ["Nutrition basics", "Local government", "Traditional art techniques"]
      }
    },
    term2: {
      weeks: "1-10",
      themes: ["Communication Skills", "Operations and Measurement", "Our Environment"],
      subjects: {
        languageCommunication: ["Report writing", "Comprehension strategies", "Group discussions", "Visual interpretation"],
        mathematics: ["Multiplication facts", "Perimeter", "Coordinates", "Data collection"],
        science: ["Adaptation", "Physical changes", "Energy forms"],
        livingInCommunity: ["Safety at home and school", "Community responsibilities", "Music and rhythm"]
      }
    },
    term3: {
      weeks: "1-10",
      themes: ["Advanced Reading", "Problem Solving", "Earth and Beyond"],
      subjects: {
        languageCommunication: ["Fiction and non-fiction", "Persuasive speaking", "Letter writing", "Media analysis"],
        mathematics: ["Division strategies", "Fractions", "2D and 3D shapes", "Probability introduction"],
        science: ["Circuits", "Weather patterns", "Rock types"],
        livingInCommunity: ["First aid basics", "Environmental action", "Cultural presentations"]
      }
    },
    term4: {
      weeks: "1-10",
      themes: ["Year Review", "Assessment", "Year 5 Preparation"],
      subjects: {
        languageCommunication: ["Writing portfolio", "Reading assessment", "Speech presentation", "Visual project"],
        mathematics: ["Number mastery", "Operations review", "Geometry project", "Data presentation"],
        science: ["Science investigation", "Year review", "Science fair"],
        livingInCommunity: ["Health review", "Community project", "Cultural celebration"]
      }
    }
  },
  "Year 5": {
    term1: {
      weeks: "1-10",
      themes: ["Critical Literacy", "Extending Number Skills", "Human Body"],
      subjects: {
        languageCommunication: ["Essay structure", "Inferencing", "Debate introduction", "Graph analysis"],
        mathematics: ["Numbers to 99,999", "Multi-digit multiplication", "Area concepts", "Algebraic patterns"],
        science: ["Body systems", "Mixtures", "Energy efficiency"],
        livingInCommunity: ["Puberty education", "National government", "Comparative cultures"]
      }
    },
    term2: {
      weeks: "1-10",
      themes: ["Research Skills", "Fractions and Decimals", "Ecosystems"],
      subjects: {
        languageCommunication: ["Research reports", "Critical reading", "Formal presentations", "Advertisement critique"],
        mathematics: ["Fraction operations", "Decimal concepts", "Symmetry", "Mean, median, mode"],
        science: ["Food webs", "Separation methods", "Magnetism"],
        livingInCommunity: ["Stress management", "Social issues", "Artistic expression"]
      }
    },
    term3: {
      weeks: "1-10",
      themes: ["Creative Expression", "Geometry and Data", "Space and Earth"],
      subjects: {
        languageCommunication: ["Creative writing", "Poetry analysis", "Speech delivery", "Documentary viewing"],
        mathematics: ["Coordinate geometry", "Probability", "Problem solving", "Data projects"],
        science: ["Solar system", "Natural disasters", "Renewable energy"],
        livingInCommunity: ["Health planning", "Community service", "Performance arts"]
      }
    },
    term4: {
      weeks: "1-10",
      themes: ["Year Review", "Assessment", "Year 6 Preparation"],
      subjects: {
        languageCommunication: ["Essay portfolio", "Literary review", "Debate showcase", "Media project"],
        mathematics: ["Number mastery", "Fraction/decimal review", "Geometry assessment", "Statistics project"],
        science: ["Science portfolio", "Investigation skills", "Environmental project"],
        livingInCommunity: ["Health assessment", "Leadership project", "Cultural showcase"]
      }
    }
  },
  "Year 6": {
    term1: {
      weeks: "1-10",
      themes: ["Academic Writing", "Advanced Mathematics", "Scientific Method"],
      subjects: {
        languageCommunication: ["Research essays", "Literary analysis", "Public speaking", "Media literacy"],
        mathematics: ["Large numbers", "Order of operations", "Transformations", "Statistical investigations"],
        science: ["Cells and genetics", "Chemical reactions", "Simple machines"],
        livingInCommunity: ["Substance prevention", "Global citizenship", "Cultural identity"]
      }
    },
    term2: {
      weeks: "1-10",
      themes: ["Persuasion and Argument", "Algebra and Probability", "Environmental Science"],
      subjects: {
        languageCommunication: ["Argumentative writing", "Source evaluation", "Debate", "Visual presentations"],
        mathematics: ["Variables and equations", "Probability calculations", "Scale drawings", "Data comparison"],
        science: ["Disease prevention", "Acids and bases", "Climate change"],
        livingInCommunity: ["Health goals", "Leadership", "Cross-cultural appreciation"]
      }
    },
    term3: {
      weeks: "1-10",
      themes: ["Secondary Preparation", "Problem Solving", "Integration"],
      subjects: {
        languageCommunication: ["Portfolio completion", "Presentation skills", "Exam preparation", "Multimedia projects"],
        mathematics: ["All operations review", "Complex problems", "Geometry applications", "Statistical projects"],
        science: ["Integrated investigations", "Technology and society", "Environmental action"],
        livingInCommunity: ["Emergency response", "Transition planning", "Cultural showcase"]
      }
    },
    term4: {
      weeks: "1-10",
      themes: ["Final Assessment", "Secondary Transition", "Graduation"],
      subjects: {
        languageCommunication: ["Final portfolio", "Research presentation", "Exit interview", "Graduation speech"],
        mathematics: ["Comprehensive review", "Problem solving assessment", "Math competition", "Real-world applications"],
        science: ["Final investigation", "Science exhibition", "Technology project"],
        livingInCommunity: ["Life skills review", "Secondary orientation", "Graduation ceremony"]
      }
    }
  }
};

// Scheme of Work Templates for Years 4-6
export const schemeOfWorkTemplatesYears4to6 = {
  "Year 4": {
    languageCommunication: {
      term1: [
        { week: 1, topic: "Building Paragraphs", outcomes: "Write topic sentences and supporting details", activities: "Paragraph structure, topic sentence practice" },
        { week: 2, topic: "Reading Fluency", outcomes: "Read aloud with expression and accuracy", activities: "Partner reading, fluency timing" },
        { week: 3, topic: "Oral Presentations", outcomes: "Present ideas clearly to class", activities: "Show and tell in English, peer feedback" },
        { week: 4, topic: "Comprehension Strategies", outcomes: "Use strategies to understand texts", activities: "Predicting, questioning, summarizing" },
        { week: 5, topic: "Grammar: Verbs", outcomes: "Use correct verb tenses", activities: "Verb games, tense practice" },
        { week: 6, topic: "Report Writing Introduction", outcomes: "Write simple information reports", activities: "Structure analysis, report planning" },
        { week: 7, topic: "Charts and Graphs", outcomes: "Read and interpret visual data", activities: "Graph reading activities" },
        { week: 8, topic: "Vocabulary Building", outcomes: "Expand English vocabulary", activities: "Word maps, context clues" },
        { week: 9, topic: "Group Discussion", outcomes: "Participate in class discussions", activities: "Discussion circles, speaking turns" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate term learning", activities: "Revision activities, term test" }
      ]
    },
    mathematics: {
      term1: [
        { week: 1, topic: "Place Value to 9,999", outcomes: "Read and write numbers to 9,999", activities: "Place value games, number building" },
        { week: 2, topic: "Comparing Numbers", outcomes: "Compare and order large numbers", activities: "Number ordering, comparison games" },
        { week: 3, topic: "Addition Strategies", outcomes: "Add numbers using multiple strategies", activities: "Mental math, written methods" },
        { week: 4, topic: "Subtraction Strategies", outcomes: "Subtract with regrouping", activities: "Column subtraction, word problems" },
        { week: 5, topic: "Introduction to Angles", outcomes: "Identify right, acute, obtuse angles", activities: "Angle hunt, angle measurement" },
        { week: 6, topic: "Pattern Rules", outcomes: "Describe patterns using rules", activities: "Pattern creation, rule finding" },
        { week: 7, topic: "Multiplication Facts", outcomes: "Recall multiplication facts", activities: "Times tables games, arrays" },
        { week: 8, topic: "Perimeter", outcomes: "Calculate perimeter of shapes", activities: "Measuring perimeter, word problems" },
        { week: 9, topic: "Problem Solving", outcomes: "Solve multi-step problems", activities: "Problem solving strategies" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate term learning", activities: "Revision, term test" }
      ]
    },
    science: {
      term1: [
        { week: 1, topic: "Animal Classification", outcomes: "Classify animals into vertebrate groups", activities: "Animal sorting, characteristic identification" },
        { week: 2, topic: "Vertebrate Groups", outcomes: "Describe mammals, birds, fish, reptiles, amphibians", activities: "Group research, presentations" },
        { week: 3, topic: "Invertebrates", outcomes: "Identify common invertebrates", activities: "Insect observation, classification" },
        { week: 4, topic: "Food Chains", outcomes: "Create and explain food chains", activities: "Food chain models, ecosystem games" },
        { week: 5, topic: "Food Webs", outcomes: "Understand interconnected food webs", activities: "Web of life activity, role play" },
        { week: 6, topic: "Adaptations", outcomes: "Explain how animals adapt to environments", activities: "Adaptation research, camouflage activity" },
        { week: 7, topic: "Human Body - Skeleton", outcomes: "Identify major bones and their functions", activities: "Skeleton model, bone labeling" },
        { week: 8, topic: "Human Body - Muscles", outcomes: "Explain how muscles work with bones", activities: "Movement experiments, muscle identification" },
        { week: 9, topic: "Keeping Healthy", outcomes: "Describe ways to stay healthy", activities: "Health posters, nutrition planning" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate science learning", activities: "Science quiz, project presentations" }
      ]
    },
    livingInCommunity: {
      term1: [
        { week: 1, topic: "Vanuatu Government", outcomes: "Explain government structure", activities: "Government diagram, role research" },
        { week: 2, topic: "Parliament and Laws", outcomes: "Understand how laws are made", activities: "Mock parliament, law discussion" },
        { week: 3, topic: "Local Government", outcomes: "Describe local council roles", activities: "Community leader interviews" },
        { week: 4, topic: "Being a Good Citizen", outcomes: "Demonstrate citizenship responsibilities", activities: "Community service planning" },
        { week: 5, topic: "Healthy Eating", outcomes: "Plan balanced meals", activities: "Food group sorting, meal planning" },
        { week: 6, topic: "Exercise and Fitness", outcomes: "Explain importance of exercise", activities: "Fitness activities, health diary" },
        { week: 7, topic: "Personal Safety", outcomes: "Identify unsafe situations", activities: "Safety scenarios, action planning" },
        { week: 8, topic: "Money Management", outcomes: "Understand saving and spending", activities: "Budget activities, saving goals" },
        { week: 9, topic: "Community Problem Solving", outcomes: "Propose solutions to community issues", activities: "Problem identification, action plans" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate community learning", activities: "Project presentations, assessment" }
      ]
    }
  },
  "Year 5": {
    languageCommunication: {
      term1: [
        { week: 1, topic: "Essay Structure", outcomes: "Write essays with introduction, body, conclusion", activities: "Essay planning, structure analysis" },
        { week: 2, topic: "Inferencing", outcomes: "Make inferences from texts", activities: "Reading between the lines activities" },
        { week: 3, topic: "Introduction to Debate", outcomes: "Understand debate structure", activities: "Simple debates, argument building" },
        { week: 4, topic: "Research Skills", outcomes: "Find and evaluate information", activities: "Library research, source checking" },
        { week: 5, topic: "Grammar: Complex Sentences", outcomes: "Write complex sentences", activities: "Sentence combining, connectives" },
        { week: 6, topic: "Persuasive Writing", outcomes: "Write to persuade readers", activities: "Persuasive techniques, advertisements" },
        { week: 7, topic: "Graph and Table Analysis", outcomes: "Analyse data displays", activities: "Data interpretation tasks" },
        { week: 8, topic: "Formal Speaking", outcomes: "Speak formally in presentations", activities: "Speech writing and delivery" },
        { week: 9, topic: "Novel Study", outcomes: "Analyse characters and themes", activities: "Literature circles, response journals" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate term learning", activities: "Revision, term assessment" }
      ]
    },
    mathematics: {
      term1: [
        { week: 1, topic: "Numbers to 99,999", outcomes: "Read, write, compare large numbers", activities: "Place value activities, number lines" },
        { week: 2, topic: "Multi-digit Multiplication", outcomes: "Multiply 2-digit by 2-digit numbers", activities: "Area models, standard algorithm" },
        { week: 3, topic: "Division with Remainders", outcomes: "Divide with remainders", activities: "Division strategies, word problems" },
        { week: 4, topic: "Area of Rectangles", outcomes: "Calculate area using formula", activities: "Area measurement, problem solving" },
        { week: 5, topic: "Algebraic Patterns", outcomes: "Describe patterns algebraically", activities: "Pattern to equation activities" },
        { week: 6, topic: "Fraction Concepts", outcomes: "Understand equivalent fractions", activities: "Fraction models, equivalence" },
        { week: 7, topic: "Adding Fractions", outcomes: "Add fractions with like denominators", activities: "Fraction addition practice" },
        { week: 8, topic: "Introduction to Decimals", outcomes: "Understand decimal notation", activities: "Money and decimals, place value" },
        { week: 9, topic: "Problem Solving", outcomes: "Solve complex problems", activities: "Multi-step problems, strategies" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate term learning", activities: "Revision activities, term test" }
      ]
    },
    science: {
      term1: [
        { week: 1, topic: "Human Body - Digestive System", outcomes: "Trace path of food through body", activities: "Digestive system model, sequencing" },
        { week: 2, topic: "Human Body - Respiratory System", outcomes: "Explain how we breathe", activities: "Lung model, breathing experiments" },
        { week: 3, topic: "Human Body - Circulatory System", outcomes: "Describe blood circulation", activities: "Heart model, pulse measurement" },
        { week: 4, topic: "Keeping Our Bodies Healthy", outcomes: "Plan healthy lifestyle choices", activities: "Health action plans, guest speakers" },
        { week: 5, topic: "Energy Sources", outcomes: "Identify different energy sources", activities: "Energy audit, renewable vs non-renewable" },
        { week: 6, topic: "Simple Machines", outcomes: "Explain how machines make work easier", activities: "Machine building, efficiency testing" },
        { week: 7, topic: "Forces and Motion", outcomes: "Describe forces affecting motion", activities: "Force experiments, friction testing" },
        { week: 8, topic: "Earth's Resources", outcomes: "Explain sustainable resource use", activities: "Resource investigation, conservation plans" },
        { week: 9, topic: "Climate and Weather", outcomes: "Distinguish climate from weather", activities: "Weather tracking, climate research" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate science learning", activities: "Science fair, assessment" }
      ]
    },
    livingInCommunity: {
      term1: [
        { week: 1, topic: "Growing Up - Physical Changes", outcomes: "Understand puberty changes", activities: "Age-appropriate discussion, Q&A" },
        { week: 2, topic: "Growing Up - Emotional Changes", outcomes: "Manage emotions during puberty", activities: "Coping strategies, peer support" },
        { week: 3, topic: "Personal Hygiene", outcomes: "Practice advanced hygiene routines", activities: "Hygiene planning, product knowledge" },
        { week: 4, topic: "Healthy Relationships", outcomes: "Describe qualities of good relationships", activities: "Relationship mapping, scenario discussion" },
        { week: 5, topic: "Environmental Issues", outcomes: "Identify environmental challenges", activities: "Issue research, impact analysis" },
        { week: 6, topic: "Environmental Action", outcomes: "Plan environmental action projects", activities: "Project planning, implementation" },
        { week: 7, topic: "Pacific Neighbours", outcomes: "Learn about Pacific island nations", activities: "Country research, presentations" },
        { week: 8, topic: "Global Connections", outcomes: "Understand global interdependence", activities: "Trade web, cultural exchange" },
        { week: 9, topic: "Future Planning", outcomes: "Set personal goals", activities: "Goal setting, action planning" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate community learning", activities: "Portfolio review, assessment" }
      ]
    }
  },
  "Year 6": {
    languageCommunication: {
      term1: [
        { week: 1, topic: "Research Essay Planning", outcomes: "Plan and structure research essays", activities: "Topic selection, outline creation" },
        { week: 2, topic: "Literary Analysis", outcomes: "Analyse literary techniques", activities: "Figurative language study" },
        { week: 3, topic: "Public Speaking", outcomes: "Deliver effective speeches", activities: "Speech writing, delivery practice" },
        { week: 4, topic: "Source Evaluation", outcomes: "Evaluate source reliability", activities: "Fact vs opinion, bias detection" },
        { week: 5, topic: "Grammar: Advanced Structures", outcomes: "Use sophisticated grammar", activities: "Sentence variety, voice" },
        { week: 6, topic: "Argumentative Writing", outcomes: "Write balanced arguments", activities: "Thesis development, evidence use" },
        { week: 7, topic: "Media Literacy", outcomes: "Critically analyse media", activities: "Advertisement analysis, news critique" },
        { week: 8, topic: "Presentation Skills", outcomes: "Create and deliver presentations", activities: "Visual aids, speaking techniques" },
        { week: 9, topic: "Portfolio Development", outcomes: "Compile writing portfolio", activities: "Selection, reflection, editing" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate term learning", activities: "Revision, term assessment" }
      ]
    },
    mathematics: {
      term1: [
        { week: 1, topic: "Large Numbers", outcomes: "Work with numbers to 999,999", activities: "Place value, rounding" },
        { week: 2, topic: "Order of Operations", outcomes: "Apply BODMAS/PEMDAS", activities: "Order of operations practice" },
        { week: 3, topic: "Fraction Operations", outcomes: "Add and subtract fractions", activities: "Mixed numbers, unlike denominators" },
        { week: 4, topic: "Percentages", outcomes: "Calculate percentages", activities: "Percentage problems, discounts" },
        { week: 5, topic: "Transformations", outcomes: "Perform geometric transformations", activities: "Reflection, rotation, translation" },
        { week: 6, topic: "Variables and Equations", outcomes: "Solve simple equations", activities: "Balance method, algebra tiles" },
        { week: 7, topic: "Area of Triangles", outcomes: "Calculate area of triangles", activities: "Formula application, problem solving" },
        { week: 8, topic: "Statistical Investigations", outcomes: "Conduct statistical inquiries", activities: "Data collection, analysis, presentation" },
        { week: 9, topic: "Problem Solving", outcomes: "Solve complex real-world problems", activities: "Multi-step investigations" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate term learning", activities: "Revision, term test" }
      ]
    },
    science: {
      term1: [
        { week: 1, topic: "Electricity Basics", outcomes: "Understand electrical concepts", activities: "Circuit vocabulary, safety rules" },
        { week: 2, topic: "Simple Circuits", outcomes: "Build and test circuits", activities: "Circuit building, troubleshooting" },
        { week: 3, topic: "Conductors and Insulators", outcomes: "Classify materials by conductivity", activities: "Material testing, sorting" },
        { week: 4, topic: "Series and Parallel Circuits", outcomes: "Compare circuit types", activities: "Circuit comparison experiments" },
        { week: 5, topic: "Earth in Space", outcomes: "Explain Earth's position in solar system", activities: "Solar system models, scale activities" },
        { week: 6, topic: "Day, Night, and Seasons", outcomes: "Explain Earth's movements", activities: "Demonstration, modeling" },
        { week: 7, topic: "Moon Phases", outcomes: "Identify and explain moon phases", activities: "Moon observation, phase modeling" },
        { week: 8, topic: "Climate Change", outcomes: "Understand causes and effects", activities: "Research, impact mapping" },
        { week: 9, topic: "Taking Action for Environment", outcomes: "Plan environmental actions", activities: "Action project planning" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate science learning", activities: "Science exhibition, assessment" }
      ]
    },
    livingInCommunity: {
      term1: [
        { week: 1, topic: "Leadership Qualities", outcomes: "Identify qualities of good leaders", activities: "Leader research, quality analysis" },
        { week: 2, topic: "Student Leadership", outcomes: "Practice leadership in school", activities: "Leadership projects, peer mentoring" },
        { week: 3, topic: "Citizenship and Voting", outcomes: "Understand democratic processes", activities: "Mock elections, voter education" },
        { week: 4, topic: "Human Rights", outcomes: "Explain universal human rights", activities: "Rights research, case studies" },
        { week: 5, topic: "Career Exploration", outcomes: "Explore career options", activities: "Career research, guest speakers" },
        { week: 6, topic: "Secondary School Preparation", outcomes: "Prepare for transition", activities: "Study skills, time management" },
        { week: 7, topic: "Financial Literacy", outcomes: "Understand basic financial concepts", activities: "Budgeting, saving, banking" },
        { week: 8, topic: "Digital Citizenship", outcomes: "Use technology responsibly", activities: "Online safety, digital footprint" },
        { week: 9, topic: "Future Goals", outcomes: "Set long-term personal goals", activities: "Goal setting, vision boards" },
        { week: 10, topic: "Review and Assessment", outcomes: "Demonstrate readiness for Year 7", activities: "Portfolio, assessment, celebration" }
      ]
    }
  }
};

// Worksheet Templates for Years 4-6
export const worksheetTemplatesYears4to6 = {
  "Year 4": {
    languageCommunication: [
      {
        id: "ws-y4-lang-1",
        title: "Paragraph Writing",
        type: "writing",
        instructions: "Write a paragraph about your favorite place. Include a topic sentence and 3 supporting details.",
        content: "Topic Sentence: _________________________________\nDetail 1: _________________________________\nDetail 2: _________________________________\nDetail 3: _________________________________\nConclusion: _________________________________",
        answerKey: {
          rubric: {
            excellent: "Topic sentence clearly states main idea; 3 relevant supporting details; logical conclusion that summarizes the paragraph",
            good: "Topic sentence present; 2-3 supporting details; conclusion present",
            developing: "Attempts topic sentence; 1-2 supporting details; may lack conclusion",
            beginning: "Incomplete paragraph structure; limited details"
          },
          sampleAnswer: "My favorite place is the beach near my village. First, I love the warm sand under my feet. Second, the blue water is perfect for swimming. Third, I can find beautiful shells to collect. The beach is a special place where I feel happy and free."
        }
      },
      {
        id: "ws-y4-lang-2",
        title: "Verb Tenses",
        type: "grammar",
        instructions: "Complete each sentence with the correct form of the verb in brackets.",
        items: ["Yesterday, I ___ (walk) to school.", "She ___ (read) a book every day.", "Tomorrow, we ___ (go) to the market."],
        answerKey: {
          answers: [
            { sentence: "Yesterday, I ___ (walk) to school.", answer: "walked", tense: "past" },
            { sentence: "She ___ (read) a book every day.", answer: "reads", tense: "present" },
            { sentence: "Tomorrow, we ___ (go) to the market.", answer: "will go", tense: "future" }
          ]
        }
      },
      {
        id: "ws-y4-lang-3",
        title: "Adjectives and Adverbs",
        type: "grammar",
        instructions: "Identify whether the underlined word is an adjective or adverb.",
        items: [
          "The TALL tree stood in the garden.",
          "She sang BEAUTIFULLY at the concert.",
          "The QUICK brown fox jumped.",
          "He ran QUICKLY to catch the bus."
        ],
        answerKey: {
          answers: [
            { word: "TALL", answer: "Adjective", reason: "Describes the noun 'tree'" },
            { word: "BEAUTIFULLY", answer: "Adverb", reason: "Describes how she sang (verb)" },
            { word: "QUICK", answer: "Adjective", reason: "Describes the noun 'fox'" },
            { word: "QUICKLY", answer: "Adverb", reason: "Describes how he ran (verb)" }
          ]
        }
      }
    ],
    mathematics: [
      {
        id: "ws-y4-math-1",
        title: "Four Operations Practice",
        type: "operations",
        instructions: "Solve each problem. Show your working.",
        problems: ["3,456 + 2,789 = ___", "6,000 - 2,345 = ___", "34 × 7 = ___", "156 ÷ 12 = ___"],
        answerKey: {
          answers: [
            { problem: "3,456 + 2,789", answer: "6,245", working: "3,456 + 2,789 = 6,245" },
            { problem: "6,000 - 2,345", answer: "3,655", working: "6,000 - 2,345 = 3,655" },
            { problem: "34 × 7", answer: "238", working: "34 × 7 = 238" },
            { problem: "156 ÷ 12", answer: "13", working: "156 ÷ 12 = 13" }
          ]
        }
      },
      {
        id: "ws-y4-math-2",
        title: "Perimeter Problems",
        type: "measurement",
        instructions: "Calculate the perimeter of each shape.",
        content: "Rectangle: length 8cm, width 5cm. Perimeter = ___\nSquare: side 6cm. Perimeter = ___",
        answerKey: {
          answers: [
            { shape: "Rectangle", dimensions: "length 8cm, width 5cm", answer: "26cm", formula: "P = 2(l + w) = 2(8 + 5) = 2 × 13 = 26cm" },
            { shape: "Square", dimensions: "side 6cm", answer: "24cm", formula: "P = 4s = 4 × 6 = 24cm" }
          ]
        }
      },
      {
        id: "ws-y4-math-3",
        title: "Multiplication Tables (3, 4, 6, 7, 8, 9)",
        type: "operations",
        instructions: "Complete the multiplication facts.",
        problems: ["7 × 8 = ___", "6 × 9 = ___", "8 × 8 = ___", "9 × 7 = ___", "4 × 12 = ___"],
        answerKey: {
          answers: [
            { problem: "7 × 8", answer: "56" },
            { problem: "6 × 9", answer: "54" },
            { problem: "8 × 8", answer: "64" },
            { problem: "9 × 7", answer: "63" },
            { problem: "4 × 12", answer: "48" }
          ]
        }
      },
      {
        id: "ws-y4-math-4",
        title: "Fractions Introduction",
        type: "fractions",
        instructions: "Shade the correct fraction of each shape.",
        items: ["Shade 1/2 of the circle", "Shade 1/4 of the square", "Shade 3/4 of the rectangle"],
        answerKey: {
          answers: [
            { fraction: "1/2", description: "Half the shape should be shaded" },
            { fraction: "1/4", description: "One quarter of the shape should be shaded" },
            { fraction: "3/4", description: "Three quarters of the shape should be shaded" }
          ]
        }
      }
    ],
    science: [
      {
        id: "ws-y4-sci-1",
        title: "Classification of Animals",
        type: "classification",
        instructions: "Classify each animal as Vertebrate or Invertebrate.",
        items: ["Fish", "Butterfly", "Dog", "Snail", "Bird", "Worm"],
        answerKey: {
          vertebrates: ["Fish", "Dog", "Bird"],
          invertebrates: ["Butterfly", "Snail", "Worm"],
          explanation: "Vertebrates have backbones/spines; invertebrates do not"
        }
      },
      {
        id: "ws-y4-sci-2",
        title: "Simple Circuits",
        type: "labeling",
        instructions: "Label the parts of the circuit and identify if it is open or closed.",
        items: ["Battery", "Wire", "Bulb", "Switch"],
        answerKey: {
          parts: [
            { name: "Battery", function: "Provides electrical energy" },
            { name: "Wire", function: "Conducts electricity" },
            { name: "Bulb", function: "Converts electrical energy to light" },
            { name: "Switch", function: "Opens or closes the circuit" }
          ],
          circuitTypes: {
            closed: "Circuit is complete, electricity flows, bulb lights up",
            open: "Circuit has a gap, electricity cannot flow, bulb stays off"
          }
        }
      }
    ]
  },
  "Year 5": {
    languageCommunication: [
      {
        id: "ws-y5-lang-1",
        title: "Essay Planning",
        type: "writing",
        instructions: "Plan an essay about 'The Importance of Education'",
        content: "Introduction: _________________________________\nBody Paragraph 1 (Reason 1): _________________________________\nBody Paragraph 2 (Reason 2): _________________________________\nBody Paragraph 3 (Reason 3): _________________________________\nConclusion: _________________________________",
        answerKey: {
          rubric: {
            excellent: "Clear thesis; 3 well-developed body paragraphs with evidence; strong conclusion restating main points",
            good: "Thesis present; 2-3 body paragraphs with some evidence; conclusion present",
            developing: "Basic thesis; 1-2 body paragraphs; weak evidence; basic conclusion",
            beginning: "Incomplete essay structure; limited development"
          },
          sampleOutline: {
            introduction: "Education is the key to success and a better future for all people.",
            reason1: "Education helps people get better jobs and earn more money to support their families.",
            reason2: "Educated people can make better decisions about health and their communities.",
            reason3: "Education empowers people to contribute positively to society and solve problems.",
            conclusion: "Without education, people miss opportunities. Everyone deserves access to quality education."
          }
        }
      },
      {
        id: "ws-y5-lang-2",
        title: "Complex Sentences",
        type: "grammar",
        instructions: "Combine each pair of simple sentences into one complex sentence using the conjunction provided.",
        items: [
          "It was raining. We stayed inside. (because)",
          "She finished her homework. She went to play. (after)",
          "The sun was setting. The fishermen returned home. (when)"
        ],
        answerKey: {
          answers: [
            { simple: "It was raining. We stayed inside.", conjunction: "because", answer: "We stayed inside because it was raining." },
            { simple: "She finished her homework. She went to play.", conjunction: "after", answer: "After she finished her homework, she went to play." },
            { simple: "The sun was setting. The fishermen returned home.", conjunction: "when", answer: "When the sun was setting, the fishermen returned home." }
          ]
        }
      },
      {
        id: "ws-y5-lang-3",
        title: "Direct and Indirect Speech",
        type: "grammar",
        instructions: "Convert direct speech to indirect speech.",
        items: [
          "Maria said, 'I am going to the market.'",
          "Tom asked, 'Where is the library?'",
          "The teacher said, 'Please open your books.'"
        ],
        answerKey: {
          answers: [
            { direct: "Maria said, 'I am going to the market.'", indirect: "Maria said that she was going to the market." },
            { direct: "Tom asked, 'Where is the library?'", indirect: "Tom asked where the library was." },
            { direct: "The teacher said, 'Please open your books.'", indirect: "The teacher asked us to open our books." }
          ]
        }
      }
    ],
    mathematics: [
      {
        id: "ws-y5-math-1",
        title: "Fraction Operations",
        type: "operations",
        instructions: "Solve each fraction problem.",
        problems: ["1/2 + 1/4 = ___", "3/4 - 1/4 = ___", "2/3 + 1/6 = ___", "5/8 - 1/4 = ___"],
        answerKey: {
          answers: [
            { problem: "1/2 + 1/4", answer: "3/4", working: "2/4 + 1/4 = 3/4" },
            { problem: "3/4 - 1/4", answer: "2/4 = 1/2", working: "3/4 - 1/4 = 2/4 = 1/2" },
            { problem: "2/3 + 1/6", answer: "5/6", working: "4/6 + 1/6 = 5/6" },
            { problem: "5/8 - 1/4", answer: "3/8", working: "5/8 - 2/8 = 3/8" }
          ]
        }
      },
      {
        id: "ws-y5-math-2",
        title: "Area Calculations",
        type: "measurement",
        instructions: "Calculate the area of each rectangle.",
        problems: ["Length 12m, Width 8m. Area = ___", "Length 15cm, Width 6cm. Area = ___"],
        answerKey: {
          answers: [
            { dimensions: "Length 12m, Width 8m", answer: "96 m²", formula: "Area = l × w = 12 × 8 = 96 m²" },
            { dimensions: "Length 15cm, Width 6cm", answer: "90 cm²", formula: "Area = l × w = 15 × 6 = 90 cm²" }
          ]
        }
      },
      {
        id: "ws-y5-math-3",
        title: "Decimal Operations",
        type: "operations",
        instructions: "Solve each decimal problem.",
        problems: ["3.5 + 2.7 = ___", "8.4 - 3.6 = ___", "2.5 × 4 = ___", "12.5 ÷ 5 = ___"],
        answerKey: {
          answers: [
            { problem: "3.5 + 2.7", answer: "6.2" },
            { problem: "8.4 - 3.6", answer: "4.8" },
            { problem: "2.5 × 4", answer: "10" },
            { problem: "12.5 ÷ 5", answer: "2.5" }
          ]
        }
      },
      {
        id: "ws-y5-math-4",
        title: "Multi-Step Word Problems",
        type: "word_problems",
        instructions: "Solve each problem. Show all your working.",
        problems: [
          "A farmer has 450 coconuts. He sells 1/3 of them. How many are left?",
          "A rectangle has a perimeter of 36cm. If the length is 10cm, what is the width?",
          "Maria had 500 vatu. She spent 1/4 on food and 150 vatu on transport. How much is left?"
        ],
        answerKey: {
          answers: [
            { problem: "Coconuts", answer: "300 coconuts", working: "1/3 of 450 = 150 sold; 450 - 150 = 300 left" },
            { problem: "Rectangle width", answer: "8cm", working: "P = 2(l + w); 36 = 2(10 + w); 18 = 10 + w; w = 8cm" },
            { problem: "Maria's money", answer: "225 vatu", working: "1/4 of 500 = 125 on food; 125 + 150 = 275 spent; 500 - 275 = 225 left" }
          ]
        }
      }
    ],
    science: [
      {
        id: "ws-y5-sci-1",
        title: "Forces and Motion",
        type: "concepts",
        instructions: "Identify the type of force acting in each situation.",
        items: [
          "A ball rolling on grass slows down.",
          "A magnet attracts a paper clip.",
          "An apple falls from a tree.",
          "A boat floats on water."
        ],
        answerKey: {
          answers: [
            { situation: "Ball slowing on grass", force: "Friction", explanation: "The rough grass surface creates friction that slows the ball" },
            { situation: "Magnet attracts paper clip", force: "Magnetic force", explanation: "Magnets attract certain metals like iron" },
            { situation: "Apple falling", force: "Gravity", explanation: "Earth's gravity pulls objects towards the ground" },
            { situation: "Boat floating", force: "Buoyancy", explanation: "Water pushes up on objects, allowing them to float" }
          ]
        }
      },
      {
        id: "ws-y5-sci-2",
        title: "Earth's Layers",
        type: "labeling",
        instructions: "Label the layers of the Earth from outside to inside.",
        items: ["Crust", "Mantle", "Outer Core", "Inner Core"],
        answerKey: {
          order: ["1. Crust (outermost)", "2. Mantle", "3. Outer Core", "4. Inner Core (innermost)"],
          facts: [
            "Crust: Thin rocky outer layer where we live",
            "Mantle: Thick layer of hot rock",
            "Outer Core: Liquid metal layer",
            "Inner Core: Solid metal ball at the center"
          ]
        }
      }
    ]
  },
  "Year 6": {
    languageCommunication: [
      {
        id: "ws-y6-lang-1",
        title: "Argumentative Essay Structure",
        type: "writing",
        instructions: "Plan an argumentative essay on a topic of your choice.",
        content: "Thesis Statement: _________________________________\nArgument 1 + Evidence: _________________________________\nArgument 2 + Evidence: _________________________________\nCounter-argument + Rebuttal: _________________________________\nConclusion: _________________________________",
        answerKey: {
          rubric: {
            excellent: "Clear thesis with position; 2+ strong arguments with evidence; addresses counter-argument effectively; strong conclusion",
            good: "Thesis present; 2 arguments with some evidence; attempts counter-argument; conclusion present",
            developing: "Basic thesis; 1-2 arguments; limited evidence; weak counter-argument handling",
            beginning: "Unclear position; arguments not developed; no counter-argument addressed"
          },
          sampleTopic: "Should students wear school uniforms?",
          sampleOutline: {
            thesis: "All students should wear school uniforms because they promote equality and focus on learning.",
            argument1: "Uniforms reduce bullying based on clothing choices and family income differences.",
            argument2: "Students spend less time choosing outfits and can focus more on their studies.",
            counterArgument: "Some say uniforms limit self-expression, but students can express themselves through achievements, sports, and activities.",
            conclusion: "School uniforms create a fair learning environment where all students feel equal."
          }
        }
      },
      {
        id: "ws-y6-lang-2",
        title: "Figurative Language",
        type: "vocabulary",
        instructions: "Identify the type of figurative language used in each sentence.",
        items: [
          "The stars danced in the night sky.",
          "Life is a journey with many paths.",
          "The thunder roared like an angry lion.",
          "I've told you a million times!"
        ],
        answerKey: {
          answers: [
            { sentence: "The stars danced in the night sky.", type: "Personification", explanation: "Giving human qualities (dancing) to non-human things (stars)" },
            { sentence: "Life is a journey with many paths.", type: "Metaphor", explanation: "Directly comparing life to a journey without using 'like' or 'as'" },
            { sentence: "The thunder roared like an angry lion.", type: "Simile", explanation: "Comparing thunder to a lion using 'like'" },
            { sentence: "I've told you a million times!", type: "Hyperbole", explanation: "Exaggeration for emphasis" }
          ]
        }
      },
      {
        id: "ws-y6-lang-3",
        title: "Active and Passive Voice",
        type: "grammar",
        instructions: "Convert each sentence from active to passive voice.",
        items: [
          "The dog chased the cat.",
          "Maria baked a delicious cake.",
          "The students cleaned the classroom."
        ],
        answerKey: {
          answers: [
            { active: "The dog chased the cat.", passive: "The cat was chased by the dog." },
            { active: "Maria baked a delicious cake.", passive: "A delicious cake was baked by Maria." },
            { active: "The students cleaned the classroom.", passive: "The classroom was cleaned by the students." }
          ],
          rule: "In passive voice, the object becomes the subject, and the verb changes to 'was/were + past participle'"
        }
      }
    ],
    mathematics: [
      {
        id: "ws-y6-math-1",
        title: "Percentages and Ratios",
        type: "operations",
        instructions: "Solve each problem.",
        problems: ["25% of 120 = ___", "40% of 250 = ___", "If 3:5 = x:20, find x = ___", "Express 3/4 as a percentage = ___"],
        answerKey: {
          answers: [
            { problem: "25% of 120", answer: "30", working: "25/100 × 120 = 30" },
            { problem: "40% of 250", answer: "100", working: "40/100 × 250 = 100" },
            { problem: "3:5 = x:20, find x", answer: "12", working: "x/20 = 3/5; x = 3 × 20 ÷ 5 = 12" },
            { problem: "3/4 as percentage", answer: "75%", working: "3/4 × 100 = 75%" }
          ]
        }
      },
      {
        id: "ws-y6-math-2",
        title: "Order of Operations",
        type: "operations",
        instructions: "Solve using correct order of operations (BODMAS).",
        problems: ["3 + 4 × 5 = ___", "(8 + 2) × 3 = ___", "24 ÷ 6 + 2 × 4 = ___", "15 - 3 × (2 + 1) = ___"],
        answerKey: {
          answers: [
            { problem: "3 + 4 × 5", answer: "23", working: "3 + (4 × 5) = 3 + 20 = 23" },
            { problem: "(8 + 2) × 3", answer: "30", working: "(10) × 3 = 30" },
            { problem: "24 ÷ 6 + 2 × 4", answer: "12", working: "4 + 8 = 12" },
            { problem: "15 - 3 × (2 + 1)", answer: "6", working: "15 - 3 × 3 = 15 - 9 = 6" }
          ],
          rule: "BODMAS: Brackets, Orders, Division/Multiplication (left to right), Addition/Subtraction (left to right)"
        }
      },
      {
        id: "ws-y6-math-3",
        title: "Volume of Rectangular Prisms",
        type: "measurement",
        instructions: "Calculate the volume of each rectangular prism.",
        problems: [
          "Length 5cm, Width 4cm, Height 3cm. Volume = ___",
          "Length 8m, Width 6m, Height 2m. Volume = ___"
        ],
        answerKey: {
          answers: [
            { dimensions: "5cm × 4cm × 3cm", answer: "60 cm³", formula: "V = l × w × h = 5 × 4 × 3 = 60 cm³" },
            { dimensions: "8m × 6m × 2m", answer: "96 m³", formula: "V = l × w × h = 8 × 6 × 2 = 96 m³" }
          ]
        }
      },
      {
        id: "ws-y6-math-4",
        title: "Algebra - Simple Equations",
        type: "algebra",
        instructions: "Solve for the unknown variable.",
        problems: ["x + 7 = 15", "3y = 24", "z - 9 = 12", "2a + 5 = 17"],
        answerKey: {
          answers: [
            { equation: "x + 7 = 15", answer: "x = 8", working: "x = 15 - 7 = 8" },
            { equation: "3y = 24", answer: "y = 8", working: "y = 24 ÷ 3 = 8" },
            { equation: "z - 9 = 12", answer: "z = 21", working: "z = 12 + 9 = 21" },
            { equation: "2a + 5 = 17", answer: "a = 6", working: "2a = 17 - 5 = 12; a = 12 ÷ 2 = 6" }
          ]
        }
      }
    ],
    science: [
      {
        id: "ws-y6-sci-1",
        title: "Renewable vs Non-Renewable Energy",
        type: "classification",
        instructions: "Classify each energy source as Renewable or Non-Renewable.",
        items: ["Solar", "Coal", "Wind", "Natural Gas", "Hydroelectric", "Oil"],
        answerKey: {
          renewable: ["Solar", "Wind", "Hydroelectric"],
          nonRenewable: ["Coal", "Natural Gas", "Oil"],
          explanation: "Renewable sources can be replenished naturally; non-renewable sources are finite and will eventually run out"
        }
      },
      {
        id: "ws-y6-sci-2",
        title: "Human Body Systems Review",
        type: "matching",
        instructions: "Match each organ to its primary function.",
        items: [
          { organ: "Heart", functions: ["Pumps blood", "Filters blood", "Digests food"], answer: "Pumps blood" },
          { organ: "Kidney", functions: ["Pumps blood", "Filters blood", "Digests food"], answer: "Filters blood" },
          { organ: "Stomach", functions: ["Pumps blood", "Filters blood", "Digests food"], answer: "Digests food" },
          { organ: "Brain", functions: ["Controls body", "Produces hormones", "Stores energy"], answer: "Controls body" }
        ],
        answerKey: {
          answers: [
            { organ: "Heart", function: "Pumps blood throughout the body (Circulatory System)" },
            { organ: "Kidney", function: "Filters blood and removes waste (Excretory System)" },
            { organ: "Stomach", function: "Digests food and absorbs nutrients (Digestive System)" },
            { organ: "Brain", function: "Controls all body functions (Nervous System)" }
          ]
        }
      },
      {
        id: "ws-y6-sci-3",
        title: "Climate Change Causes and Effects",
        type: "concepts",
        instructions: "Match each cause with its effect on the environment.",
        items: [
          "Burning fossil fuels → ___",
          "Deforestation → ___",
          "Rising temperatures → ___"
        ],
        answerKey: {
          answers: [
            { cause: "Burning fossil fuels", effect: "Increases CO₂ in atmosphere, contributing to global warming" },
            { cause: "Deforestation", effect: "Reduces oxygen production and increases CO₂ (trees absorb CO₂)" },
            { cause: "Rising temperatures", effect: "Melting ice caps, rising sea levels, extreme weather events" }
          ]
        }
      }
    ]
  }
};

// Lesson Plan Templates for Years 4-6
export const lessonPlanTemplatesYears4to6 = {
  "Year 4": {
    languageCommunication: [
      {
        id: "lp-y4-lang-1",
        week: 1,
        topic: "Building Paragraphs",
        duration: "50 minutes",
        objectives: [
          "Identify the parts of a paragraph",
          "Write a topic sentence",
          "Add supporting details to develop ideas"
        ],
        materials: ["Example paragraphs", "Paragraph planning sheets", "Highlighters"],
        introduction: {
          time: "10 min",
          activity: "Read a model paragraph. Students identify the topic sentence and supporting details using highlighters."
        },
        development: [
          { time: "15 min", activity: "Direct Instruction: Explain the TEEL structure (Topic, Explain, Evidence, Link). Show examples." },
          { time: "15 min", activity: "Guided Practice: Together, write a class paragraph about 'Our School'. Students suggest ideas." },
          { time: "10 min", activity: "Independent Practice: Students plan their own paragraph about 'My Family' using a planning sheet." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Share: 3-4 students share their topic sentences. Quick check for understanding."
        },
        assessment: "Can students write a topic sentence and identify at least 2 supporting details?",
        homework: "Complete the paragraph about 'My Family'"
      },
      {
        id: "lp-y4-lang-2",
        week: 2,
        topic: "Reading Fluency",
        duration: "50 minutes",
        objectives: [
          "Read aloud with appropriate speed and expression",
          "Use punctuation to guide reading",
          "Self-correct reading errors"
        ],
        materials: ["Leveled reading texts", "Fluency rubric", "Timer"],
        introduction: {
          time: "5 min",
          activity: "Teacher models fluent reading, demonstrating expression and pausing at punctuation."
        },
        development: [
          { time: "15 min", activity: "Echo Reading: Teacher reads a sentence, students echo with same expression." },
          { time: "15 min", activity: "Partner Reading: Pairs take turns reading paragraphs, giving feedback on fluency." },
          { time: "10 min", activity: "Timed Reading: Students read a passage for one minute while partner counts words." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Reflection: What helps you read fluently? Share tips with the class."
        },
        assessment: "Fluency check using rubric (accuracy, rate, expression)",
        homework: "Practice reading tonight's passage 3 times"
      }
    ],
    mathematics: [
      {
        id: "lp-y4-math-1",
        week: 1,
        topic: "Place Value to 9,999",
        duration: "50 minutes",
        objectives: [
          "Read and write numbers to 9,999",
          "Identify the value of each digit",
          "Represent numbers using base-10 materials"
        ],
        materials: ["Base-10 blocks", "Place value charts", "Number cards"],
        introduction: {
          time: "5 min",
          activity: "Review: Count by 100s to 1,000. Introduce: 'Today we go further - to 9,999!'"
        },
        development: [
          { time: "15 min", activity: "Concrete: Use base-10 blocks to build 4-digit numbers. Identify thousands, hundreds, tens, ones." },
          { time: "15 min", activity: "Pictorial: Draw representations on place value charts. Practice reading numbers aloud." },
          { time: "10 min", activity: "Abstract: Write numbers in standard form, expanded form, and word form." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Exit Ticket: Write the number 5,382 in words and expanded form."
        },
        assessment: "Can students correctly identify place values and write numbers in different forms?",
        homework: "Practice worksheet: Place value to 9,999"
      }
    ],
    science: [
      {
        id: "lp-y4-sci-1",
        week: 1,
        topic: "Animal Classification",
        duration: "50 minutes",
        objectives: [
          "Classify animals into vertebrate groups (mammals, birds, fish, reptiles, amphibians)",
          "Identify key characteristics of each group",
          "Sort local animals into correct groups"
        ],
        materials: ["Animal pictures", "Classification chart", "Local animal examples"],
        introduction: {
          time: "8 min",
          activity: "Show pictures of different animals. 'How are these animals different? How can we group them?'"
        },
        development: [
          { time: "15 min", activity: "Learn the 5 vertebrate groups: mammals (hair, milk), birds (feathers, eggs), fish (scales, gills), reptiles (dry scales), amphibians (moist skin)." },
          { time: "15 min", activity: "Sorting Activity: In groups, sort animal picture cards into correct categories. Justify choices." },
          { time: "7 min", activity: "Local Focus: Name Vanuatu animals in each group (flying fox, coconut crab, green sea turtle)." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Quiz: Teacher shows animal, students hold up card showing which group it belongs to."
        },
        assessment: "Can students correctly classify animals and explain key characteristics?",
        homework: "Find and draw 2 animals from each vertebrate group"
      },
      {
        id: "lp-y4-sci-2",
        week: 2,
        topic: "Food Chains and Food Webs",
        duration: "50 minutes",
        objectives: [
          "Understand how energy flows from sun to producers to consumers",
          "Create simple food chains",
          "Explain the role of decomposers"
        ],
        materials: ["Food chain diagrams", "Animal and plant cards", "String or yarn"],
        introduction: {
          time: "8 min",
          activity: "Ask: 'What did you eat today? Where did that food come from?' Trace back to the sun."
        },
        development: [
          { time: "15 min", activity: "Build Food Chains: Sun → producer (plant) → primary consumer (herbivore) → secondary consumer (carnivore). Use local examples." },
          { time: "12 min", activity: "Food Web Activity: Connect multiple food chains with string to show the web of connections." },
          { time: "10 min", activity: "Decomposers: Learn how fungi and bacteria break down dead matter and return nutrients to soil." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Draw a food chain from the garden or reef ecosystem."
        },
        assessment: "Can students create a correct food chain and explain energy flow?",
        homework: "Create a food web poster for a local ecosystem"
      }
    ],
    livingInCommunity: [
      {
        id: "lp-y4-lic-1",
        week: 1,
        topic: "Vanuatu Government",
        duration: "50 minutes",
        objectives: [
          "Understand the structure of Vanuatu's government",
          "Identify the roles of Parliament, Prime Minister, and President",
          "Explain how leaders are chosen"
        ],
        materials: ["Government structure diagram", "Pictures of leaders", "Map of Vanuatu"],
        introduction: {
          time: "8 min",
          activity: "Who makes the rules in Vanuatu? How do they get their job? Discuss what students already know."
        },
        development: [
          { time: "15 min", activity: "Government Structure: Parliament (makes laws), Prime Minister (leads government), President (head of state). Draw diagram together." },
          { time: "12 min", activity: "Elections: How do people become MPs? What is voting? Why is it important? Role play voting." },
          { time: "10 min", activity: "Local Connection: Who is the MP for our area? What do they do for our community?" }
        ],
        conclusion: {
          time: "5 min",
          activity: "Reflection: Why is it important to have a government? What would happen without one?"
        },
        assessment: "Can students explain the basic structure of Vanuatu's government?",
        homework: "Interview a family member about voting"
      },
      {
        id: "lp-y4-lic-2",
        week: 2,
        topic: "Healthy Eating and Nutrition",
        duration: "50 minutes",
        objectives: [
          "Identify the main food groups",
          "Understand the importance of balanced meals",
          "Plan a healthy meal using local foods"
        ],
        materials: ["Food group chart", "Local food pictures", "Meal planning template"],
        introduction: {
          time: "5 min",
          activity: "Show two meals: one balanced, one not. Which is healthier? Why?"
        },
        development: [
          { time: "15 min", activity: "Food Groups: Learn about carbohydrates (taro, rice), proteins (fish, beans), fruits/vegetables, fats. Local examples for each." },
          { time: "15 min", activity: "Meal Planning: In pairs, plan a healthy breakfast, lunch, and dinner using local foods. Include all food groups." },
          { time: "10 min", activity: "Share and Discuss: Groups present their meal plans. Class gives feedback on balance." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Personal Goal: 'One healthy eating change I will make this week is...'"
        },
        assessment: "Can students create a balanced meal plan using all food groups?",
        homework: "Help prepare a healthy meal at home and write about it"
      }
    ]
  },
  "Year 5": {
    languageCommunication: [
      {
        id: "lp-y5-lang-1",
        week: 1,
        topic: "Essay Structure",
        duration: "50 minutes",
        objectives: [
          "Understand the parts of an essay",
          "Write an effective introduction with a thesis",
          "Plan body paragraphs with clear points"
        ],
        materials: ["Essay examples", "Planning templates", "Checklist"],
        introduction: {
          time: "10 min",
          activity: "Analyse a model essay together. Label introduction, body paragraphs, conclusion. Identify the thesis statement."
        },
        development: [
          { time: "15 min", activity: "Focus on Introductions: Elements of a hook, background, thesis. Students practice writing hooks." },
          { time: "15 min", activity: "Body Paragraph Planning: Use graphic organizer to plan 3 main points with supporting details." },
          { time: "5 min", activity: "Quick Write: Draft thesis statement for chosen topic." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Peer Check: Share thesis statements with partner for feedback."
        },
        assessment: "Can students write a clear thesis statement and identify essay components?",
        homework: "Complete essay outline for homework"
      }
    ],
    mathematics: [
      {
        id: "lp-y5-math-1",
        week: 1,
        topic: "Numbers to 99,999",
        duration: "50 minutes",
        objectives: [
          "Read, write, and represent 5-digit numbers",
          "Compare and order large numbers",
          "Round to the nearest 1,000 and 10,000"
        ],
        materials: ["Place value charts", "Number lines", "Comparison cards"],
        introduction: {
          time: "5 min",
          activity: "Quick Review: Place value of 4-digit numbers. Challenge: 'What comes after 9,999?'"
        },
        development: [
          { time: "15 min", activity: "Building 5-Digit Numbers: Use place value charts to show ten thousands place. Read and write numbers." },
          { time: "15 min", activity: "Comparing Numbers: Use inequality symbols (<, >, =). Order sets of 5-digit numbers." },
          { time: "10 min", activity: "Rounding: Round numbers to nearest 1,000 and 10,000 using number lines." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Game: Number Battle - pairs compare 5-digit numbers, higher number wins."
        },
        assessment: "Can students correctly place value, compare, and round 5-digit numbers?",
        homework: "Complete place value practice worksheet"
      }
    ],
    science: [
      {
        id: "lp-y5-sci-1",
        week: 1,
        topic: "Human Body Systems - Digestive System",
        duration: "50 minutes",
        objectives: [
          "Identify the main organs of the digestive system",
          "Explain the journey of food through the body",
          "Understand the importance of digestion"
        ],
        materials: ["Digestive system diagram", "Model or video", "Food samples"],
        introduction: {
          time: "8 min",
          activity: "Ask: 'What happens to the food you eat?' Brainstorm as class. Show digestive system diagram."
        },
        development: [
          { time: "15 min", activity: "Organ Tour: Mouth (chewing, saliva) → Esophagus (swallowing) → Stomach (churning, acid) → Intestines (absorbing nutrients) → Waste removal." },
          { time: "15 min", activity: "Interactive Model: Create a simple model or act out the journey of a piece of bread through the digestive system." },
          { time: "7 min", activity: "Connection to Health: Why is chewing important? What happens if we eat too fast?" }
        ],
        conclusion: {
          time: "5 min",
          activity: "Label a blank digestive system diagram. Quick quiz on organ functions."
        },
        assessment: "Can students name digestive organs and explain the path of food?",
        homework: "Create a comic strip showing food's journey through the body"
      },
      {
        id: "lp-y5-sci-2",
        week: 2,
        topic: "Energy and Simple Machines",
        duration: "50 minutes",
        objectives: [
          "Understand that machines make work easier",
          "Identify simple machines (lever, pulley, wheel and axle, inclined plane)",
          "Find examples of simple machines in daily life"
        ],
        materials: ["Simple machine examples", "Building materials", "Pictures"],
        introduction: {
          time: "5 min",
          activity: "Demo: Try to lift heavy box directly vs using a ramp. Which is easier? Why?"
        },
        development: [
          { time: "15 min", activity: "Learn 4 Simple Machines: Lever (seesaw), Pulley (flag pole), Wheel and Axle (doorknob), Inclined Plane (ramp). How each helps." },
          { time: "15 min", activity: "Building Challenge: Groups build a simple machine to lift a small weight. Test and compare designs." },
          { time: "10 min", activity: "Machine Hunt: Identify simple machines around the school and community. List and categorize." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Draw and label a simple machine found at home. Explain how it makes work easier."
        },
        assessment: "Can students identify and explain 4 types of simple machines?",
        homework: "Find 5 simple machines at home and identify their type"
      }
    ],
    livingInCommunity: [
      {
        id: "lp-y5-lic-1",
        week: 1,
        topic: "Understanding Puberty",
        duration: "50 minutes",
        objectives: [
          "Understand physical changes during puberty",
          "Learn about emotional changes and how to cope",
          "Develop personal hygiene practices"
        ],
        materials: ["Puberty education materials", "Hygiene products examples", "Anonymous question box"],
        introduction: {
          time: "8 min",
          activity: "Explain that growing up involves changes. It's normal and happens to everyone. Create safe, respectful environment for questions."
        },
        development: [
          { time: "15 min", activity: "Physical Changes: Discuss growth spurts, voice changes, skin changes. Separate groups for gender-specific discussion." },
          { time: "12 min", activity: "Emotional Changes: Mood swings, new feelings are normal. Coping strategies: talking to trusted adult, exercise, journaling." },
          { time: "10 min", activity: "Hygiene: Importance of bathing, deodorant, clean clothes. Practical tips for personal care." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Anonymous Question Box: Students can write questions to be answered next lesson. Remind them of trusted adults to talk to."
        },
        assessment: "Observation of participation and understanding shown in discussion",
        homework: "Create a personal hygiene routine chart"
      },
      {
        id: "lp-y5-lic-2",
        week: 2,
        topic: "Environmental Conservation",
        duration: "50 minutes",
        objectives: [
          "Understand environmental challenges facing Vanuatu",
          "Identify ways to reduce, reuse, recycle",
          "Plan an environmental action project"
        ],
        materials: ["Pictures of environmental issues", "Recycled materials", "Project planning sheets"],
        introduction: {
          time: "8 min",
          activity: "Show pictures: plastic on beaches, coral bleaching, deforestation. 'What do you see? How does it make you feel? What can we do?'"
        },
        development: [
          { time: "15 min", activity: "Environmental Issues: Discuss climate change, ocean pollution, loss of forests. How these affect Vanuatu specifically." },
          { time: "12 min", activity: "3 Rs Workshop: Reduce (use less), Reuse (find new uses), Recycle (make new things). Hands-on activity with recycled materials." },
          { time: "10 min", activity: "Action Planning: Groups plan a small project (beach cleanup, tree planting, awareness posters) for the community." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Commitment: 'I promise to help our environment by...' Share one action each."
        },
        assessment: "Can students explain environmental issues and propose solutions?",
        homework: "Implement one waste reduction practice at home"
      }
    ]
  },
  "Year 6": {
    languageCommunication: [
      {
        id: "lp-y6-lang-1",
        week: 1,
        topic: "Research Essay Planning",
        duration: "50 minutes",
        objectives: [
          "Select and narrow a research topic",
          "Generate research questions",
          "Create a structured essay outline"
        ],
        materials: ["Topic lists", "Research question guides", "Outline templates"],
        introduction: {
          time: "10 min",
          activity: "Discuss research process. Brainstorm possible topics related to Vanuatu (culture, environment, history)."
        },
        development: [
          { time: "15 min", activity: "Topic Selection: Students choose and narrow topics. Generate 3-5 research questions." },
          { time: "15 min", activity: "Outline Development: Create detailed outline with thesis, main points, potential sources." },
          { time: "5 min", activity: "Peer Conference: Share outlines and research questions for feedback." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Set research goals for the week. Discuss available resources."
        },
        assessment: "Has student selected appropriate topic with clear research questions and outline?",
        homework: "Begin research using school and community resources"
      }
    ],
    mathematics: [
      {
        id: "lp-y6-math-1",
        week: 1,
        topic: "Order of Operations",
        duration: "50 minutes",
        objectives: [
          "Understand the need for order of operations",
          "Apply BODMAS/PEMDAS correctly",
          "Solve multi-step calculations"
        ],
        materials: ["BODMAS poster", "Practice cards", "Calculators for checking"],
        introduction: {
          time: "10 min",
          activity: "Problem: 3 + 4 × 5 = ? Discuss why we need agreed rules. Introduce BODMAS."
        },
        development: [
          { time: "15 min", activity: "Direct Teaching: Work through examples of each operation in order. Emphasize brackets first." },
          { time: "15 min", activity: "Guided Practice: Solve problems together, students indicating which operation to do first." },
          { time: "5 min", activity: "Challenge Problems: Include problems with multiple operations and brackets." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Quick Quiz: 5 problems to solve independently. Check with calculators."
        },
        assessment: "Can students correctly apply order of operations to multi-step problems?",
        homework: "Order of operations practice worksheet"
      }
    ],
    science: [
      {
        id: "lp-y6-sci-1",
        week: 1,
        topic: "Electricity and Circuits",
        duration: "50 minutes",
        objectives: [
          "Understand basic concepts of electricity",
          "Build simple electrical circuits",
          "Explain conductors and insulators"
        ],
        materials: ["Batteries", "Wires", "Bulbs", "Switches", "Various materials for testing"],
        introduction: {
          time: "8 min",
          activity: "Discuss: Where do we use electricity? What would life be like without it? Safety rules for electricity."
        },
        development: [
          { time: "15 min", activity: "Circuit Building: Build a simple circuit with battery, wire, and bulb. Understand the complete path needed for current flow." },
          { time: "12 min", activity: "Switches: Add a switch to the circuit. Understand how switches break and complete the circuit." },
          { time: "10 min", activity: "Conductors and Insulators: Test various materials (metal, plastic, wood, rubber). Which complete the circuit? Sort into categories." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Challenge: Can you make the bulb brighter? (add another battery) Draw and label a complete circuit."
        },
        assessment: "Can students build a working circuit and identify conductors/insulators?",
        homework: "Design a circuit diagram for a simple flashlight"
      },
      {
        id: "lp-y6-sci-2",
        week: 2,
        topic: "Earth and Space - Climate Change",
        duration: "50 minutes",
        objectives: [
          "Understand causes of climate change",
          "Identify impacts on Pacific islands",
          "Propose actions to address climate change"
        ],
        materials: ["Climate data charts", "Videos", "World map", "Action planning sheets"],
        introduction: {
          time: "10 min",
          activity: "Show before/after images of glacier melt, rising seas. Ask: 'What's happening? Why might this affect Vanuatu?'"
        },
        development: [
          { time: "15 min", activity: "Causes: Greenhouse effect, fossil fuels, deforestation. How human actions contribute to warming." },
          { time: "12 min", activity: "Pacific Impacts: Sea level rise, cyclones, coral bleaching, food security. Vanuatu as one of the most vulnerable countries." },
          { time: "8 min", activity: "Solutions: Personal actions (reduce, reuse, plant trees), community actions, and what world leaders can do." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Write a letter to a leader about climate action. Share key points."
        },
        assessment: "Can students explain climate change causes, impacts, and solutions?",
        homework: "Research one climate change solution and present to family"
      }
    ],
    livingInCommunity: [
      {
        id: "lp-y6-lic-1",
        week: 1,
        topic: "Leadership and Citizenship",
        duration: "50 minutes",
        objectives: [
          "Understand qualities of good leaders",
          "Identify ways to be a responsible citizen",
          "Plan a leadership project for school or community"
        ],
        materials: ["Pictures of leaders", "Case studies", "Project planning templates"],
        introduction: {
          time: "8 min",
          activity: "Who are some leaders you admire? What makes them good leaders? Brainstorm qualities (honesty, courage, kindness, responsibility)."
        },
        development: [
          { time: "15 min", activity: "Leadership Qualities: Discuss vision, communication, service, integrity. Examples from Vanuatu history and current leaders." },
          { time: "12 min", activity: "Citizenship: Rights come with responsibilities. How can young people contribute? (respecting others, helping community, caring for environment)" },
          { time: "10 min", activity: "Project Planning: Groups identify a need at school or community. Plan a project to address it (cleanup, tutoring younger students, awareness campaign)." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Commitment: Share project plans. 'I will show leadership by...' Create action timeline."
        },
        assessment: "Can students identify leadership qualities and plan a meaningful project?",
        homework: "Interview a community leader about their leadership journey"
      },
      {
        id: "lp-y6-lic-2",
        week: 2,
        topic: "Preparing for Secondary School",
        duration: "50 minutes",
        objectives: [
          "Understand what to expect in secondary school",
          "Develop study skills and time management",
          "Set academic and personal goals"
        ],
        materials: ["Secondary school information", "Study tips handouts", "Goal-setting templates"],
        introduction: {
          time: "8 min",
          activity: "What do you know about secondary school? What are you excited about? What worries you? Address questions openly."
        },
        development: [
          { time: "12 min", activity: "What's Different: More subjects, different teachers, more independence, more homework. Tips from former students (video or guest speaker)." },
          { time: "13 min", activity: "Study Skills: Note-taking, organizing materials, time management, asking for help. Create a study schedule." },
          { time: "12 min", activity: "Goal Setting: Set 3 goals - one academic, one personal, one social - for Year 7. Make them SMART (Specific, Measurable, Achievable, Relevant, Time-bound)." }
        ],
        conclusion: {
          time: "5 min",
          activity: "Letter to Future Self: Write a letter to read at the end of Year 7. Include hopes, goals, and promises."
        },
        assessment: "Has student created realistic goals and a study plan?",
        homework: "Share goals with family and get their support"
      }
    ]
  }
};

// Test Blueprint Templates for Years 4-6
export const testBlueprintTemplatesYears4to6 = {
  "Year 4": {
    languageCommunication: {
      term1: {
        title: "Term 1 Language Assessment Blueprint - Year 4",
        totalMarks: 60,
        duration: "45 minutes",
        sections: [
          {
            name: "Reading Comprehension",
            marks: 20,
            questions: 8,
            description: "Read passages and answer questions about main ideas, details, and vocabulary",
            sampleItems: ["What is the main idea?", "Find a word that means...", "Why did the character..."]
          },
          {
            name: "Grammar and Vocabulary",
            marks: 20,
            questions: 10,
            description: "Demonstrate understanding of verb tenses, sentence structure, and vocabulary",
            sampleItems: ["Choose the correct verb form", "What is the opposite of...", "Complete the sentence"]
          },
          {
            name: "Writing",
            marks: 20,
            questions: 2,
            description: "Write a paragraph and complete a short report",
            sampleItems: ["Write a paragraph about...", "Complete the report on..."]
          }
        ],
        rubric: {
          excellent: { range: "50-60", description: "Exceeds Year 4 expectations in all areas" },
          good: { range: "38-49", description: "Meets Year 4 expectations" },
          developing: { range: "25-37", description: "Approaching Year 4 expectations" },
          beginning: { range: "0-24", description: "Below Year 4 expectations" }
        }
      }
    },
    mathematics: {
      term1: {
        title: "Term 1 Mathematics Assessment Blueprint - Year 4",
        totalMarks: 60,
        duration: "45 minutes",
        sections: [
          {
            name: "Number and Operations",
            marks: 25,
            questions: 10,
            description: "Four operations with numbers to 9,999",
            sampleItems: ["4,567 + 2,345 =", "6,000 - 3,456 =", "45 × 8 =", "144 ÷ 12 ="]
          },
          {
            name: "Measurement and Geometry",
            marks: 20,
            questions: 8,
            description: "Perimeter, angles, shapes",
            sampleItems: ["Calculate the perimeter", "Identify the angle type", "Name the shape"]
          },
          {
            name: "Word Problems",
            marks: 15,
            questions: 5,
            description: "Multi-step problems using all operations",
            sampleItems: ["A farmer has... How many...?", "If the cost is... What is the total?"]
          }
        ],
        rubric: {
          excellent: { range: "50-60", description: "Strong mathematical understanding" },
          good: { range: "38-49", description: "Good grasp of Year 4 concepts" },
          developing: { range: "25-37", description: "Developing mathematical skills" },
          beginning: { range: "0-24", description: "Needs additional support" }
        }
      }
    }
  },
  "Year 5": {
    languageCommunication: {
      term1: {
        title: "Term 1 Language Assessment Blueprint - Year 5",
        totalMarks: 70,
        duration: "50 minutes",
        sections: [
          {
            name: "Reading Comprehension and Analysis",
            marks: 25,
            questions: 10,
            description: "Comprehension, inference, and basic analysis",
            sampleItems: ["What can you infer about...?", "What is the author's purpose?", "Compare the characters"]
          },
          {
            name: "Grammar and Language Use",
            marks: 20,
            questions: 10,
            description: "Complex sentences, verb forms, vocabulary in context",
            sampleItems: ["Combine the sentences", "Choose the correct form", "Define the word using context"]
          },
          {
            name: "Essay Writing",
            marks: 25,
            questions: 1,
            description: "Write a structured essay on a given topic",
            sampleItems: ["Write an essay explaining..."]
          }
        ],
        rubric: {
          excellent: { range: "58-70", description: "Exceeds Year 5 expectations" },
          good: { range: "44-57", description: "Meets Year 5 expectations" },
          developing: { range: "28-43", description: "Approaching Year 5 expectations" },
          beginning: { range: "0-27", description: "Below Year 5 expectations" }
        }
      }
    },
    mathematics: {
      term1: {
        title: "Term 1 Mathematics Assessment Blueprint - Year 5",
        totalMarks: 70,
        duration: "50 minutes",
        sections: [
          {
            name: "Number Operations and Fractions",
            marks: 30,
            questions: 12,
            description: "Multi-digit operations, fractions, decimals introduction",
            sampleItems: ["45,678 + 23,456 =", "3/4 + 1/4 =", "Convert 0.5 to a fraction"]
          },
          {
            name: "Measurement and Geometry",
            marks: 20,
            questions: 8,
            description: "Area, symmetry, coordinates",
            sampleItems: ["Calculate the area", "Draw the line of symmetry", "Plot the coordinates"]
          },
          {
            name: "Problem Solving and Data",
            marks: 20,
            questions: 6,
            description: "Complex problems, data interpretation",
            sampleItems: ["Calculate the mean", "Interpret the graph", "Solve the multi-step problem"]
          }
        ],
        rubric: {
          excellent: { range: "58-70", description: "Strong mathematical reasoning" },
          good: { range: "44-57", description: "Good understanding of concepts" },
          developing: { range: "28-43", description: "Developing mathematical skills" },
          beginning: { range: "0-27", description: "Requires intervention" }
        }
      }
    }
  },
  "Year 6": {
    languageCommunication: {
      term1: {
        title: "Term 1 Language Assessment Blueprint - Year 6",
        totalMarks: 80,
        duration: "60 minutes",
        sections: [
          {
            name: "Critical Reading",
            marks: 30,
            questions: 12,
            description: "Analysis, evaluation, synthesis of texts",
            sampleItems: ["Evaluate the author's argument", "Identify bias in the text", "Synthesize information from both texts"]
          },
          {
            name: "Language and Grammar",
            marks: 20,
            questions: 10,
            description: "Advanced grammar, vocabulary, style",
            sampleItems: ["Identify the figurative language", "Improve the sentence", "Use the word in context"]
          },
          {
            name: "Extended Writing",
            marks: 30,
            questions: 1,
            description: "Write an argumentative or research-based essay",
            sampleItems: ["Write an argumentative essay on..."]
          }
        ],
        rubric: {
          excellent: { range: "68-80", description: "Ready for secondary school" },
          good: { range: "52-67", description: "Meets Year 6 expectations" },
          developing: { range: "32-51", description: "Approaching expectations" },
          beginning: { range: "0-31", description: "Needs significant support" }
        }
      }
    },
    mathematics: {
      term1: {
        title: "Term 1 Mathematics Assessment Blueprint - Year 6",
        totalMarks: 80,
        duration: "60 minutes",
        sections: [
          {
            name: "Number, Fractions, Percentages",
            marks: 30,
            questions: 12,
            description: "All operations, fractions, decimals, percentages, ratios",
            sampleItems: ["Calculate 35% of 240", "Solve: x + 7 = 15", "Express 3:5 as a percentage"]
          },
          {
            name: "Geometry and Measurement",
            marks: 25,
            questions: 10,
            description: "Area, transformations, scale, angles",
            sampleItems: ["Calculate the area of the triangle", "Perform the rotation", "Use the scale to calculate"]
          },
          {
            name: "Problem Solving and Statistics",
            marks: 25,
            questions: 8,
            description: "Complex problems, probability, data analysis",
            sampleItems: ["Calculate the probability", "Analyse the data set", "Design an investigation"]
          }
        ],
        rubric: {
          excellent: { range: "68-80", description: "Ready for secondary mathematics" },
          good: { range: "52-67", description: "Solid Year 6 understanding" },
          developing: { range: "32-51", description: "Developing mathematical competence" },
          beginning: { range: "0-31", description: "Requires mathematical intervention" }
        }
      }
    }
  }
};

// Complete Test Papers for Years 4-6
export const testPapersYears4to6 = {
  "Year 4": {
    languageCommunication: {
      term1: {
        id: "y4-lang-t1",
        title: "Year 4 Language & Communication - Term 1 Test",
        subject: "Language and Communication",
        totalMarks: 60,
        duration: "45 minutes",
        instructions: [
          "Write your name clearly at the top.",
          "Read all questions carefully before answering.",
          "Write in complete sentences where required.",
          "Check your work before submitting."
        ],
        sections: [
          {
            name: "Section A: Reading Comprehension",
            marks: 20,
            passage: "The coconut tree is one of the most useful trees in Vanuatu. Every part of the tree can be used. The trunk is used for building houses and canoes. The leaves are woven into baskets and mats. The coconut fruit provides food, drink, and oil. Coconut water is refreshing and healthy. The white meat inside can be eaten fresh or dried to make copra. Coconut oil is used for cooking, lighting lamps, and making soap. Even the shell can be used to make cups and decorations. For these reasons, the coconut tree is often called 'the tree of life.'",
            instructions: "Read the passage and answer the questions.",
            questions: [
              { id: 1, question: "What is the main idea of this passage?", type: "short_answer", answer: "The coconut tree is very useful/valuable", marks: 3 },
              { id: 2, question: "Name TWO things made from coconut leaves.", type: "short_answer", answer: "Baskets and mats", marks: 2 },
              { id: 3, question: "What is copra?", type: "short_answer", answer: "Dried coconut meat", marks: 2 },
              { id: 4, question: "Why is the coconut tree called 'the tree of life'?", type: "short_answer", answer: "Because every part can be used/it is very useful", marks: 3 },
              { id: 5, question: "Name THREE uses for coconut oil.", type: "short_answer", answer: "Cooking, lighting lamps, making soap", marks: 3 },
              { id: 6, question: "What does 'refreshing' mean in this passage?", options: ["Tiring", "Cool and pleasant", "Expensive"], answer: "Cool and pleasant", marks: 2 },
              { id: 7, question: "What can be made from coconut shells?", type: "short_answer", answer: "Cups and decorations", marks: 2 },
              { id: 8, question: "Which part of the coconut tree is used for building?", options: ["Leaves", "Trunk", "Fruit"], answer: "Trunk", marks: 3 }
            ]
          },
          {
            name: "Section B: Grammar and Vocabulary",
            marks: 20,
            instructions: "Answer each grammar question.",
            questions: [
              { id: 9, question: "Choose the correct verb: The children ___ playing in the yard.", options: ["is", "are", "was"], answer: "are", marks: 2 },
              { id: 10, question: "Choose the correct verb: She ___ to school every day.", options: ["walk", "walks", "walking"], answer: "walks", marks: 2 },
              { id: 11, question: "What is the past tense of 'eat'?", options: ["eated", "ate", "eaten"], answer: "ate", marks: 2 },
              { id: 12, question: "Find the adjective: The tall man carried heavy bags.", options: ["man", "carried", "tall"], answer: "tall", marks: 2 },
              { id: 13, question: "The opposite of 'large' is:", options: ["big", "small", "huge"], answer: "small", marks: 2 },
              { id: 14, question: "Choose the correct punctuation: What time is it___", options: [".", "!", "?"], answer: "?", marks: 2 },
              { id: 15, question: "A word that means 'happy' is:", options: ["sad", "joyful", "angry"], answer: "joyful", marks: 2 },
              { id: 16, question: "Complete: He is ___ strongest boy in the class.", options: ["a", "an", "the"], answer: "the", marks: 2 },
              { id: 17, question: "Which is a compound sentence?", options: ["I went home.", "I went home and ate dinner.", "Going home."], answer: "I went home and ate dinner.", marks: 2 },
              { id: 18, question: "Choose the plural: One child, many ___", options: ["childs", "childrens", "children"], answer: "children", marks: 2 }
            ]
          },
          {
            name: "Section C: Writing",
            marks: 20,
            instructions: "Write clearly and carefully.",
            questions: [
              { id: 19, question: "Write a paragraph (5-7 sentences) about 'My Favorite Food'. Include a topic sentence, supporting details, and a conclusion.", type: "paragraph", answer: "Well-structured paragraph with topic sentence, details, and conclusion", marks: 12 },
              { id: 20, question: "Write 3 sentences describing what you did yesterday. Use past tense verbs.", type: "sentences", answer: "Three sentences using correct past tense", marks: 8 }
            ]
          }
        ],
        answerKey: {
          sectionA: ["The coconut tree is useful", "Baskets and mats", "Dried coconut meat", "Every part can be used", "Cooking, lamps, soap", "Cool and pleasant", "Cups and decorations", "Trunk"],
          sectionB: ["are", "walks", "ate", "tall", "small", "?", "joyful", "the", "I went home and ate dinner.", "children"],
          sectionC: ["Rubric-based", "Rubric-based"]
        }
      }
    },
    mathematics: {
      term1: {
        id: "y4-math-t1",
        title: "Year 4 Mathematics - Term 1 Test",
        subject: "Mathematics",
        totalMarks: 60,
        duration: "45 minutes",
        instructions: [
          "Write your name on the paper.",
          "Show all your working.",
          "Write answers clearly.",
          "Check your calculations."
        ],
        sections: [
          {
            name: "Section A: Place Value and Number",
            marks: 20,
            instructions: "Answer questions about place value and number.",
            questions: [
              { id: 1, question: "Write 'six thousand, four hundred and twenty-three' as a number", type: "number_writing", answer: "6,423", marks: 2 },
              { id: 2, question: "Write 'eight thousand and fifty-six' as a number", type: "number_writing", answer: "8,056", marks: 2 },
              { id: 3, question: "In 5,847, what is the value of 8?", options: ["8", "80", "800"], answer: "800", marks: 2 },
              { id: 4, question: "In 3,692, what is the value of 6?", options: ["6", "60", "600"], answer: "600", marks: 2 },
              { id: 5, question: "Round 4,567 to the nearest thousand", options: ["4,000", "5,000", "4,500"], answer: "5,000", marks: 2 },
              { id: 6, question: "Which is greater: 5,432 or 5,423?", options: ["5,432", "5,423", "Same"], answer: "5,432", marks: 2 },
              { id: 7, question: "Write 7,000 + 300 + 20 + 5 in standard form", type: "number_writing", answer: "7,325", marks: 2 },
              { id: 8, question: "Arrange in order (smallest to largest): 6,789, 6,798, 6,879", type: "ordering", answer: "6,789, 6,798, 6,879", marks: 2 },
              { id: 9, question: "What number is 100 more than 4,950?", type: "calculation", answer: "5,050", marks: 2 },
              { id: 10, question: "What number is 1,000 less than 8,234?", type: "calculation", answer: "7,234", marks: 2 }
            ]
          },
          {
            name: "Section B: Operations",
            marks: 20,
            instructions: "Calculate. Show your working.",
            questions: [
              { id: 11, question: "3,456 + 2,318 = ", type: "calculation", answer: "5,774", marks: 2 },
              { id: 12, question: "5,000 - 1,234 = ", type: "calculation", answer: "3,766", marks: 2 },
              { id: 13, question: "4,567 + 3,245 = ", type: "calculation", answer: "7,812", marks: 2 },
              { id: 14, question: "6,000 - 2,847 = ", type: "calculation", answer: "3,153", marks: 2 },
              { id: 15, question: "34 × 6 = ", type: "calculation", answer: "204", marks: 2 },
              { id: 16, question: "45 × 7 = ", type: "calculation", answer: "315", marks: 2 },
              { id: 17, question: "96 ÷ 8 = ", type: "calculation", answer: "12", marks: 2 },
              { id: 18, question: "144 ÷ 12 = ", type: "calculation", answer: "12", marks: 2 },
              { id: 19, question: "What is 1/2 of 48?", type: "calculation", answer: "24", marks: 2 },
              { id: 20, question: "What is 1/4 of 100?", type: "calculation", answer: "25", marks: 2 }
            ]
          },
          {
            name: "Section C: Measurement and Word Problems",
            marks: 20,
            instructions: "Solve each problem. Show your working.",
            questions: [
              { id: 21, question: "Calculate the perimeter of a rectangle with length 12cm and width 8cm.", type: "measurement", answer: "40cm", marks: 4 },
              { id: 22, question: "Calculate the perimeter of a square with sides of 9cm.", type: "measurement", answer: "36cm", marks: 4 },
              { id: 23, question: "A shop has 2,456 mangoes. They receive 1,234 more. How many mangoes are there now?", type: "word_problem", answer: "3,690", marks: 4 },
              { id: 24, question: "There are 3,500 people at a stadium. 1,275 leave. How many are left?", type: "word_problem", answer: "2,225", marks: 4 },
              { id: 25, question: "A farmer plants 45 rows of taro with 8 plants in each row. How many plants are there altogether?", type: "word_problem", answer: "360", marks: 4 }
            ]
          }
        ],
        answerKey: {
          sectionA: ["6,423", "8,056", "800", "600", "5,000", "5,432", "7,325", "6,789, 6,798, 6,879", "5,050", "7,234"],
          sectionB: ["5,774", "3,766", "7,812", "3,153", "204", "315", "12", "12", "24", "25"],
          sectionC: ["40cm", "36cm", "3,690", "2,225", "360"]
        }
      }
    }
  },
  "Year 5": {
    languageCommunication: {
      term1: {
        id: "y5-lang-t1",
        title: "Year 5 Language & Communication - Term 1 Test",
        subject: "Language and Communication",
        totalMarks: 70,
        duration: "50 minutes",
        instructions: [
          "Write your name clearly.",
          "Read all passages carefully.",
          "Answer in complete sentences.",
          "Check spelling and grammar."
        ],
        sections: [
          {
            name: "Section A: Reading Comprehension",
            marks: 25,
            passage: "Climate change is affecting islands in the Pacific Ocean, including Vanuatu. Rising sea levels threaten coastal villages. Some communities have already had to move to higher ground. Extreme weather events like cyclones are becoming more frequent and intense.\n\nThe people of Vanuatu are taking action. They are planting mangroves to protect coastlines. They are building stronger houses that can withstand cyclones. Young people are learning about climate change in schools and spreading awareness in their communities.\n\nThe government is also working with other Pacific nations to call for global action on climate change. They argue that small island nations produce very little pollution but suffer the worst effects. International cooperation is needed to address this global challenge.",
            instructions: "Read the passage and answer the questions.",
            questions: [
              { id: 1, question: "What are TWO effects of climate change mentioned in the passage?", type: "short_answer", answer: "Rising sea levels and more frequent/intense cyclones", marks: 4 },
              { id: 2, question: "Why have some communities had to move?", type: "short_answer", answer: "Because of rising sea levels/coastal flooding", marks: 3 },
              { id: 3, question: "What are THREE actions people in Vanuatu are taking?", type: "short_answer", answer: "Planting mangroves, building stronger houses, learning about climate change", marks: 6 },
              { id: 4, question: "What does the government argue about small island nations?", type: "short_answer", answer: "They produce little pollution but suffer the worst effects", marks: 4 },
              { id: 5, question: "What is the author's main purpose?", options: ["To entertain", "To inform and persuade", "To instruct"], answer: "To inform and persuade", marks: 3 },
              { id: 6, question: "What can you infer about young people's role?", type: "short_answer", answer: "They are important for spreading awareness/future leaders", marks: 3 },
              { id: 7, question: "What does 'withstand' mean in the passage?", options: ["Build", "Resist/survive", "Destroy"], answer: "Resist/survive", marks: 2 }
            ]
          },
          {
            name: "Section B: Grammar and Language",
            marks: 20,
            instructions: "Answer the grammar questions.",
            questions: [
              { id: 8, question: "Combine using 'because': It was raining. We stayed inside.", type: "sentence_combining", answer: "We stayed inside because it was raining.", marks: 2 },
              { id: 9, question: "Change to passive voice: The dog bit the man.", type: "voice_change", answer: "The man was bitten by the dog.", marks: 2 },
              { id: 10, question: "Identify the adverb: She quickly finished her homework.", options: ["She", "quickly", "finished"], answer: "quickly", marks: 2 },
              { id: 11, question: "Choose the correct form: Neither the teacher nor the students ___ ready.", options: ["is", "are", "was"], answer: "are", marks: 2 },
              { id: 12, question: "What type of sentence is this: 'Close the door!'", options: ["Declarative", "Interrogative", "Imperative"], answer: "Imperative", marks: 2 },
              { id: 13, question: "Find the simile: Her smile was as bright as the sun.", type: "figurative_language", answer: "as bright as the sun", marks: 2 },
              { id: 14, question: "What is the root word of 'unhappiness'?", type: "word_structure", answer: "happy", marks: 2 },
              { id: 15, question: "Choose the correct word: The effect/affect of the storm was devastating.", options: ["effect", "affect"], answer: "effect", marks: 2 },
              { id: 16, question: "Add appropriate punctuation: My mother asked where are you going", type: "punctuation", answer: "My mother asked, 'Where are you going?'", marks: 2 },
              { id: 17, question: "Identify the conjunction: I wanted to swim but the water was cold.", options: ["wanted", "but", "cold"], answer: "but", marks: 2 }
            ]
          },
          {
            name: "Section C: Essay Writing",
            marks: 25,
            instructions: "Write a well-structured essay.",
            questions: [
              { id: 18, question: "Write an essay (3-4 paragraphs) on ONE of the following topics:\na) 'Why Education is Important'\nb) 'How We Can Protect Our Environment'\n\nYour essay should include:\n- An introduction with a clear thesis statement\n- Body paragraphs with main ideas and supporting details\n- A conclusion that summarizes your points", type: "essay", answer: "Rubric-based: structure, content, language", marks: 25 }
            ]
          }
        ],
        answerKey: {
          sectionA: ["Rising sea levels, cyclones", "Rising sea levels", "Mangroves, houses, learning", "Produce little pollution, suffer most", "To inform and persuade", "Important for future", "Resist/survive"],
          sectionB: ["We stayed inside because it was raining", "The man was bitten by the dog", "quickly", "are", "Imperative", "as bright as the sun", "happy", "effect", "My mother asked, 'Where are you going?'", "but"],
          sectionC: ["Rubric-based"]
        }
      }
    },
    mathematics: {
      term1: {
        id: "y5-math-t1",
        title: "Year 5 Mathematics - Term 1 Test",
        subject: "Mathematics",
        totalMarks: 70,
        duration: "50 minutes",
        instructions: [
          "Write your name on the paper.",
          "Show all working for full marks.",
          "Write answers clearly.",
          "Check calculations carefully."
        ],
        sections: [
          {
            name: "Section A: Number and Operations",
            marks: 30,
            instructions: "Calculate and show working where required.",
            questions: [
              { id: 1, question: "Write 'forty-five thousand, six hundred and seventy-eight' as a number", type: "number_writing", answer: "45,678", marks: 2 },
              { id: 2, question: "In 67,892, what is the value of 7?", options: ["7", "700", "7,000"], answer: "7,000", marks: 2 },
              { id: 3, question: "34,567 + 23,456 = ", type: "calculation", answer: "58,023", marks: 3 },
              { id: 4, question: "50,000 - 23,456 = ", type: "calculation", answer: "26,544", marks: 3 },
              { id: 5, question: "234 × 23 = ", type: "calculation", answer: "5,382", marks: 3 },
              { id: 6, question: "456 ÷ 12 = ", type: "calculation", answer: "38", marks: 3 },
              { id: 7, question: "3/4 + 1/4 = ", type: "fraction", answer: "1 (or 4/4)", marks: 2 },
              { id: 8, question: "5/6 - 2/6 = ", type: "fraction", answer: "3/6 or 1/2", marks: 2 },
              { id: 9, question: "Convert 0.75 to a fraction", type: "conversion", answer: "3/4", marks: 3 },
              { id: 10, question: "Convert 3/5 to a decimal", type: "conversion", answer: "0.6", marks: 3 },
              { id: 11, question: "What is 50% of 80?", type: "percentage", answer: "40", marks: 2 },
              { id: 12, question: "Round 67,845 to the nearest thousand", type: "rounding", answer: "68,000", marks: 2 }
            ]
          },
          {
            name: "Section B: Geometry and Measurement",
            marks: 20,
            instructions: "Calculate areas and answer geometry questions.",
            questions: [
              { id: 13, question: "Calculate the area of a rectangle with length 15cm and width 8cm", type: "area", answer: "120 cm²", marks: 3 },
              { id: 14, question: "Calculate the area of a square with sides of 12m", type: "area", answer: "144 m²", marks: 3 },
              { id: 15, question: "A rectangle has an area of 48cm² and width of 6cm. What is the length?", type: "problem", answer: "8cm", marks: 3 },
              { id: 16, question: "How many lines of symmetry does a square have?", options: ["2", "4", "8"], answer: "4", marks: 2 },
              { id: 17, question: "What are the coordinates of point A at (3, 5)?", type: "coordinates", answer: "x = 3, y = 5", marks: 3 },
              { id: 18, question: "If you move 3 units right and 2 units up from (1, 1), where are you?", type: "coordinates", answer: "(4, 3)", marks: 3 },
              { id: 19, question: "Name a shape with exactly 6 faces", type: "shape", answer: "Cube/Cuboid/Rectangular prism", marks: 3 }
            ]
          },
          {
            name: "Section C: Statistics and Problem Solving",
            marks: 20,
            instructions: "Solve problems and answer statistics questions.",
            questions: [
              { id: 20, question: "Find the mean of: 12, 15, 18, 15, 20", type: "statistics", answer: "16", marks: 4 },
              { id: 21, question: "Find the median of: 3, 7, 9, 11, 15", type: "statistics", answer: "9", marks: 3 },
              { id: 22, question: "Find the mode of: 5, 7, 7, 8, 9, 7, 10", type: "statistics", answer: "7", marks: 3 },
              { id: 23, question: "A school has 24,500 students. If 12,350 are girls, how many are boys?", type: "word_problem", answer: "12,150", marks: 5 },
              { id: 24, question: "If a bus travels at 45 km per hour, how far will it travel in 3 hours?", type: "word_problem", answer: "135 km", marks: 5 }
            ]
          }
        ],
        answerKey: {
          sectionA: ["45,678", "7,000", "58,023", "26,544", "5,382", "38", "1", "1/2", "3/4", "0.6", "40", "68,000"],
          sectionB: ["120 cm²", "144 m²", "8cm", "4", "x=3, y=5", "(4, 3)", "Cube"],
          sectionC: ["16", "9", "7", "12,150", "135 km"]
        }
      }
    }
  },
  "Year 6": {
    languageCommunication: {
      term1: {
        id: "y6-lang-t1",
        title: "Year 6 Language & Communication - Term 1 Test",
        subject: "Language and Communication",
        totalMarks: 80,
        duration: "60 minutes",
        instructions: [
          "Write your name clearly.",
          "Read all texts carefully before answering.",
          "Support your answers with evidence from the text.",
          "Proofread your writing carefully."
        ],
        sections: [
          {
            name: "Section A: Critical Reading",
            marks: 30,
            passage: "Technology has transformed education around the world. In Vanuatu, many schools now have access to computers and the internet. Students can research topics online, access educational videos, and communicate with students in other countries.\n\nHowever, some people worry about the negative effects of technology. They argue that too much screen time can harm children's health and reduce face-to-face social interaction. Traditional knowledge passed down through generations might be forgotten if young people spend all their time on devices.\n\nOthers believe the benefits outweigh the risks. Technology can help students in remote areas access the same quality education as those in towns. It can preserve traditional languages and stories through recordings and websites. The key is finding the right balance.\n\nEducators suggest that technology should be a tool, not a replacement for traditional teaching methods. When used wisely, technology can enhance learning while still valuing cultural heritage and human connection.",
            instructions: "Read the passage and answer the questions in complete sentences.",
            questions: [
              { id: 1, question: "What are TWO benefits of technology in education mentioned in the passage?", type: "short_answer", answer: "Research online, educational videos, communication with other countries, access for remote areas", marks: 4 },
              { id: 2, question: "What are TWO concerns about technology raised in the passage?", type: "short_answer", answer: "Screen time harming health, reduced social interaction, traditional knowledge forgotten", marks: 4 },
              { id: 3, question: "How can technology help preserve traditional culture?", type: "short_answer", answer: "Through recordings and websites for languages and stories", marks: 4 },
              { id: 4, question: "What is the author's position on technology in education?", type: "analysis", answer: "Balanced - technology is useful when used wisely as a tool", marks: 4 },
              { id: 5, question: "Evaluate the argument that technology helps students in remote areas. Do you agree? Explain.", type: "evaluation", answer: "Student provides reasoned argument with evidence", marks: 6 },
              { id: 6, question: "Identify ONE example of balanced language used by the author.", type: "language_analysis", answer: "Example: 'However', 'Others believe', 'finding the right balance'", marks: 4 },
              { id: 7, question: "What does 'enhance' mean in the final paragraph?", options: ["Replace", "Improve", "Reduce"], answer: "Improve", marks: 2 },
              { id: 8, question: "What is the purpose of the final paragraph?", type: "analysis", answer: "To summarize and provide a balanced conclusion/recommendation", marks: 2 }
            ]
          },
          {
            name: "Section B: Language Skills",
            marks: 20,
            instructions: "Answer the language questions.",
            questions: [
              { id: 9, question: "Identify the clause type: 'Although it was raining' is a ___ clause.", options: ["main", "subordinate", "relative"], answer: "subordinate", marks: 2 },
              { id: 10, question: "Rewrite in reported speech: 'I will come tomorrow,' said John.", type: "reported_speech", answer: "John said (that) he would come the next day.", marks: 3 },
              { id: 11, question: "Identify the metaphor: Time is money in the business world.", type: "figurative_language", answer: "Time is money", marks: 2 },
              { id: 12, question: "What is the function of a semicolon?", type: "punctuation_knowledge", answer: "To join related independent clauses", marks: 2 },
              { id: 13, question: "Rewrite with correct parallel structure: She likes swimming, to read, and cooking.", type: "grammar", answer: "She likes swimming, reading, and cooking.", marks: 3 },
              { id: 14, question: "Choose the correct word: The committee (has/have) made their decision.", options: ["has", "have"], answer: "has", marks: 2 },
              { id: 15, question: "Identify the tone of: 'This outrageous decision must be reversed immediately!'", options: ["Neutral", "Angry/urgent", "Humorous"], answer: "Angry/urgent", marks: 2 },
              { id: 16, question: "What does the prefix 'mis-' mean in 'misunderstand'?", options: ["Again", "Before", "Wrongly"], answer: "Wrongly", marks: 2 },
              { id: 17, question: "Rewrite to improve clarity: Walking down the street, the trees were beautiful.", type: "clarity", answer: "Walking down the street, I saw beautiful trees. / As I walked down the street, the trees were beautiful.", marks: 2 }
            ]
          },
          {
            name: "Section C: Extended Writing",
            marks: 30,
            instructions: "Write an argumentative essay.",
            questions: [
              { id: 18, question: "Write an argumentative essay (4-5 paragraphs) on ONE of the following:\n\na) 'Mobile phones should be banned in schools.'\nb) 'Traditional customs are more important than modern technology.'\n\nYour essay MUST include:\n- An engaging introduction with a clear thesis statement\n- At least TWO body paragraphs with arguments and evidence\n- Acknowledgment of counter-arguments\n- A strong conclusion\n- Appropriate use of persuasive language techniques", type: "argumentative_essay", answer: "Rubric: structure (6), arguments (8), evidence (6), counter-arguments (4), language (6)", marks: 30 }
            ]
          }
        ],
        answerKey: {
          sectionA: ["Research, videos, communication", "Health, social interaction, traditional knowledge", "Recordings and websites", "Balanced use", "Student response", "Language examples", "Improve", "Summary/conclusion"],
          sectionB: ["subordinate", "John said he would come the next day", "Time is money", "Join clauses", "swimming, reading, cooking", "has", "Angry/urgent", "Wrongly", "Corrected sentence"],
          sectionC: ["Rubric-based"]
        }
      }
    },
    mathematics: {
      term1: {
        id: "y6-math-t1",
        title: "Year 6 Mathematics - Term 1 Test",
        subject: "Mathematics",
        totalMarks: 80,
        duration: "60 minutes",
        instructions: [
          "Write your name on the paper.",
          "Show all working for full marks.",
          "Use correct units in your answers.",
          "Check all calculations."
        ],
        sections: [
          {
            name: "Section A: Number, Fractions, and Percentages",
            marks: 30,
            instructions: "Calculate carefully. Show working.",
            questions: [
              { id: 1, question: "Calculate: 456,789 + 234,567", type: "calculation", answer: "691,356", marks: 2 },
              { id: 2, question: "Calculate: 500,000 - 234,567", type: "calculation", answer: "265,433", marks: 2 },
              { id: 3, question: "Calculate using order of operations: 3 + 4 × 5", type: "calculation", answer: "23", marks: 2 },
              { id: 4, question: "Calculate: (8 + 4) × 3 - 6", type: "calculation", answer: "30", marks: 2 },
              { id: 5, question: "Calculate: 24 ÷ 6 + 2 × 5", type: "calculation", answer: "14", marks: 2 },
              { id: 6, question: "Solve for x: x + 15 = 42", type: "algebra", answer: "x = 27", marks: 3 },
              { id: 7, question: "Solve for x: 3x = 24", type: "algebra", answer: "x = 8", marks: 3 },
              { id: 8, question: "Calculate: 2/3 + 3/4", type: "fraction", answer: "17/12 or 1 5/12", marks: 3 },
              { id: 9, question: "Calculate: 5/6 - 1/4", type: "fraction", answer: "7/12", marks: 3 },
              { id: 10, question: "Calculate: 25% of 240", type: "percentage", answer: "60", marks: 2 },
              { id: 11, question: "Calculate: 15% of 400", type: "percentage", answer: "60", marks: 2 },
              { id: 12, question: "Express 3/5 as a percentage", type: "conversion", answer: "60%", marks: 2 },
              { id: 13, question: "A shirt costs 2,500 vatu. In a sale, it is reduced by 20%. What is the sale price?", type: "word_problem", answer: "2,000 vatu", marks: 2 }
            ]
          },
          {
            name: "Section B: Geometry and Measurement",
            marks: 25,
            instructions: "Calculate areas and solve geometry problems.",
            questions: [
              { id: 14, question: "Calculate the area of a triangle with base 12cm and height 8cm", type: "area", answer: "48 cm²", marks: 3 },
              { id: 15, question: "Calculate the area of a triangle with base 15m and height 10m", type: "area", answer: "75 m²", marks: 3 },
              { id: 16, question: "A rectangle has length 20cm and width 12cm. Calculate the perimeter and area.", type: "compound", answer: "Perimeter: 64cm, Area: 240cm²", marks: 4 },
              { id: 17, question: "If a shape is rotated 90° clockwise, which direction will an arrow pointing up now point?", options: ["Up", "Right", "Down", "Left"], answer: "Right", marks: 2 },
              { id: 18, question: "A map has a scale of 1:10,000. If two towns are 5cm apart on the map, how far apart are they in real life?", type: "scale", answer: "50,000cm or 500m or 0.5km", marks: 4 },
              { id: 19, question: "The angles in a triangle add up to 180°. If two angles are 65° and 45°, what is the third angle?", type: "angle", answer: "70°", marks: 3 },
              { id: 20, question: "How many faces does a triangular prism have?", options: ["4", "5", "6"], answer: "5", marks: 2 },
              { id: 21, question: "Calculate the perimeter of a regular hexagon with sides of 7cm", type: "perimeter", answer: "42cm", marks: 2 },
              { id: 22, question: "Convert 3.5 metres to centimetres", type: "conversion", answer: "350cm", marks: 2 }
            ]
          },
          {
            name: "Section C: Statistics, Probability, and Problem Solving",
            marks: 25,
            instructions: "Solve problems involving data and probability.",
            questions: [
              { id: 23, question: "A dice is rolled. What is the probability of rolling a 6?", type: "probability", answer: "1/6", marks: 3 },
              { id: 24, question: "A bag contains 3 red balls and 7 blue balls. What is the probability of picking a red ball?", type: "probability", answer: "3/10", marks: 3 },
              { id: 25, question: "Find the mean of: 72, 85, 68, 91, 79", type: "statistics", answer: "79", marks: 3 },
              { id: 26, question: "The test scores for 5 students are: 65, 72, 85, 72, 91. Find the mode.", type: "statistics", answer: "72", marks: 2 },
              { id: 27, question: "A bus leaves Port Vila at 7:45am and arrives in Luganville at 3:15pm. How long is the journey?", type: "time_problem", answer: "7 hours 30 minutes", marks: 4 },
              { id: 28, question: "A school has 450 students. 60% are boys. How many girls are there?", type: "percentage_problem", answer: "180", marks: 4 },
              { id: 29, question: "If 3 workers can complete a job in 12 days, how many days would it take 6 workers?", type: "proportion", answer: "6 days", marks: 3 },
              { id: 30, question: "A rectangular garden is 25m long and 18m wide. What is its area in square metres? If fencing costs 150 vatu per metre, how much would it cost to fence the garden?", type: "compound_problem", answer: "Area: 450m², Fencing: 12,900 vatu", marks: 3 }
            ]
          }
        ],
        answerKey: {
          sectionA: ["691,356", "265,433", "23", "30", "14", "27", "8", "17/12", "7/12", "60", "60", "60%", "2,000 vatu"],
          sectionB: ["48 cm²", "75 m²", "P:64cm, A:240cm²", "Right", "500m", "70°", "5", "42cm", "350cm"],
          sectionC: ["1/6", "3/10", "79", "72", "7h 30min", "180", "6 days", "450m², 12,900 vatu"]
        }
      }
    }
  }
};

export default {
  years4to6Outcomes,
  sampleActivitiesYears4to6,
  assessmentSamplesYears4to6,
  yearlyPlannerTemplatesYears4to6,
  schemeOfWorkTemplatesYears4to6,
  worksheetTemplatesYears4to6,
  lessonPlanTemplatesYears4to6,
  testBlueprintTemplatesYears4to6,
  testPapersYears4to6
};
